// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../node_modules/antd/dist/antd.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
! tailwindcss v3.3.3 | MIT License | https://tailwindcss.com
*/

/*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
*/

html {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font family by default.
2. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-size: 1em; /* 2 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/

dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/

:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */

[hidden] {
  display: none;
}

html,
	body {
		-webkit-tap-highlight-color: transparent;
	}

/* Chrome, Safari, Edge, Opera */

input::-webkit-outer-spin-button,
	input::-webkit-inner-spin-button {
		-webkit-appearance: none;
		margin: 0;
		width: 99vw;
	}

/* Firefox */

input[type="number"] {
		-moz-appearance: textfield;
	}

:is(.dark body){
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}

*, ::before, ::after{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
.container{
  width: 100%;
  margin-right: auto;
  margin-left: auto;
  padding-right: 1rem;
  padding-left: 1rem;
}
@media (min-width: 425px){

  .container{
    max-width: 425px;
  }
}
@media (min-width: 576px){

  .container{
    max-width: 576px;
  }
}
@media (min-width: 768px){

  .container{
    max-width: 768px;
  }
}
@media (min-width: 992px){

  .container{
    max-width: 992px;
  }
}
@media (min-width: 1200px){

  .container{
    max-width: 1200px;
  }
}
@media (min-width: 1400px){

  .container{
    max-width: 1400px;
  }
}
@media (min-width: 1900px){

  .container{
    max-width: 1900px;
  }
}
.stageStartBtn {
		clip-path: polygon(90% 0, 100% 50%, 90% 100%, 0% 100%, 0% 50%, 0% 0%);
	}
.stageBtn {
		clip-path: polygon(90% 0, 100% 50%, 90% 100%, 0% 100%, 10% 50%, 0% 0%);
	}
.stageEndBtn {
		clip-path: polygon(100% 0, 100% 50%, 100% 100%, 0% 100%, 10% 50%, 0% 0%);
	}
.\\!visible{
  visibility: visible !important;
}
.visible{
  visibility: visible !important;
}
.fixed{
  position: fixed !important;
}
.absolute{
  position: absolute !important;
}
.relative{
  position: relative !important;
}
.sticky{
  position: sticky !important;
}
.bottom-0{
  bottom: 0px !important;
}
.left-0{
  left: 0px !important;
}
.left-2{
  left: 0.5rem !important;
}
.right-0{
  right: 0px !important;
}
.right-2{
  right: 0.5rem !important;
}
.top-0{
  top: 0px !important;
}
.top-2{
  top: 0.5rem !important;
}
.z-10{
  z-index: 10 !important;
}
.z-20{
  z-index: 20 !important;
}
.z-30{
  z-index: 30 !important;
}
.z-50{
  z-index: 50 !important;
}
.float-right{
  float: right !important;
}
.m-0{
  margin: 0px !important;
}
.m-1{
  margin: 0.25rem !important;
}
.m-10{
  margin: 2.5rem !important;
}
.m-2{
  margin: 0.5rem !important;
}
.m-3{
  margin: 0.75rem !important;
}
.m-4{
  margin: 1rem !important;
}
.m-5{
  margin: 1.25rem !important;
}
.-mx-2{
  margin-left: -0.5rem !important;
  margin-right: -0.5rem !important;
}
.mx-5{
  margin-left: 1.25rem !important;
  margin-right: 1.25rem !important;
}
.mx-auto{
  margin-left: auto !important;
  margin-right: auto !important;
}
.my-2{
  margin-top: 0.5rem !important;
  margin-bottom: 0.5rem !important;
}
.my-3{
  margin-top: 0.75rem !important;
  margin-bottom: 0.75rem !important;
}
.my-4{
  margin-top: 1rem !important;
  margin-bottom: 1rem !important;
}
.my-5{
  margin-top: 1.25rem !important;
  margin-bottom: 1.25rem !important;
}
.-mb-8{
  margin-bottom: -2rem !important;
}
.-ml-12{
  margin-left: -3rem !important;
}
.-ml-3{
  margin-left: -0.75rem !important;
}
.-mr-5{
  margin-right: -1.25rem !important;
}
.-mt-1{
  margin-top: -0.25rem !important;
}
.mb-1{
  margin-bottom: 0.25rem !important;
}
.mb-1\\.5{
  margin-bottom: 0.375rem !important;
}
.mb-10{
  margin-bottom: 2.5rem !important;
}
.mb-2{
  margin-bottom: 0.5rem !important;
}
.mb-3{
  margin-bottom: 0.75rem !important;
}
.mb-4{
  margin-bottom: 1rem !important;
}
.mb-5{
  margin-bottom: 1.25rem !important;
}
.mb-6{
  margin-bottom: 1.5rem !important;
}
.mb-8{
  margin-bottom: 2rem !important;
}
.mb-\\[-10px\\]{
  margin-bottom: -10px !important;
}
.mb-\\[16px\\]{
  margin-bottom: 16px !important;
}
.me-2{
  margin-inline-end: 0.5rem !important;
}
.ml-1{
  margin-left: 0.25rem !important;
}
.ml-10{
  margin-left: 2.5rem !important;
}
.ml-2{
  margin-left: 0.5rem !important;
}
.ml-4{
  margin-left: 1rem !important;
}
.ml-5{
  margin-left: 1.25rem !important;
}
.ml-6{
  margin-left: 1.5rem !important;
}
.ml-auto{
  margin-left: auto !important;
}
.mr-0{
  margin-right: 0px !important;
}
.mr-10{
  margin-right: 2.5rem !important;
}
.mr-2{
  margin-right: 0.5rem !important;
}
.mr-20{
  margin-right: 5rem !important;
}
.mr-3{
  margin-right: 0.75rem !important;
}
.mr-4{
  margin-right: 1rem !important;
}
.mr-5{
  margin-right: 1.25rem !important;
}
.mr-6{
  margin-right: 1.5rem !important;
}
.mr-8{
  margin-right: 2rem !important;
}
.ms-1{
  margin-inline-start: 0.25rem !important;
}
.mt-1{
  margin-top: 0.25rem !important;
}
.mt-10{
  margin-top: 2.5rem !important;
}
.mt-2{
  margin-top: 0.5rem !important;
}
.mt-3{
  margin-top: 0.75rem !important;
}
.mt-4{
  margin-top: 1rem !important;
}
.mt-5{
  margin-top: 1.25rem !important;
}
.mt-8{
  margin-top: 2rem !important;
}
.mt-\\[-16px\\]{
  margin-top: -16px !important;
}
.box-border{
  box-sizing: border-box !important;
}
.block{
  display: block !important;
}
.inline-block{
  display: inline-block !important;
}
.inline{
  display: inline !important;
}
.\\!flex{
  display: flex !important;
}
.flex{
  display: flex !important;
}
.inline-flex{
  display: inline-flex !important;
}
.table{
  display: table !important;
}
.grid{
  display: grid !important;
}
.hidden{
  display: none !important;
}
.\\!h-11{
  height: 2.75rem !important;
}
.h-11{
  height: 2.75rem !important;
}
.h-12{
  height: 3rem !important;
}
.h-16{
  height: 4rem !important;
}
.h-20{
  height: 5rem !important;
}
.h-3{
  height: 0.75rem !important;
}
.h-40{
  height: 10rem !important;
}
.h-5{
  height: 1.25rem !important;
}
.h-6{
  height: 1.5rem !important;
}
.h-8{
  height: 2rem !important;
}
.h-96{
  height: 24rem !important;
}
.h-\\[120px\\]{
  height: 120px !important;
}
.h-\\[28px\\]{
  height: 28px !important;
}
.h-\\[40px\\]{
  height: 40px !important;
}
.h-\\[80vh\\]{
  height: 80vh !important;
}
.h-\\[85vh\\]{
  height: 85vh !important;
}
.h-\\[calc\\(100vh-100px\\)\\]{
  height: calc(100vh - 100px) !important;
}
.h-\\[calc\\(100vh-200px\\)\\]{
  height: calc(100vh - 200px) !important;
}
.h-auto{
  height: auto !important;
}
.h-full{
  height: 100% !important;
}
.min-h-\\[60vh\\]{
  min-height: 60vh !important;
}
.min-h-screen{
  min-height: 100vh !important;
}
.\\!w-full{
  width: 100% !important;
}
.w-1\\/2{
  width: 50% !important;
}
.w-16{
  width: 4rem !important;
}
.w-2\\/6{
  width: 33.333333% !important;
}
.w-20{
  width: 5rem !important;
}
.w-3{
  width: 0.75rem !important;
}
.w-4\\/5{
  width: 80% !important;
}
.w-40{
  width: 10rem !important;
}
.w-5{
  width: 1.25rem !important;
}
.w-6{
  width: 1.5rem !important;
}
.w-8{
  width: 2rem !important;
}
.w-80{
  width: 20rem !important;
}
.w-96{
  width: 24rem !important;
}
.w-\\[150px\\]{
  width: 150px !important;
}
.w-\\[163px\\]{
  width: 163px !important;
}
.w-\\[180px\\]{
  width: 180px !important;
}
.w-\\[20px\\]{
  width: 20px !important;
}
.w-\\[220px\\]{
  width: 220px !important;
}
.w-\\[240px\\]{
  width: 240px !important;
}
.w-\\[726\\.4px\\]{
  width: 726.4px !important;
}
.w-auto{
  width: auto !important;
}
.w-full{
  width: 100% !important;
}
.w-max{
  width: max-content !important;
}
.min-w-\\[100px\\]{
  min-width: 100px !important;
}
.min-w-\\[110px\\]{
  min-width: 110px !important;
}
.min-w-\\[180px\\]{
  min-width: 180px !important;
}
.min-w-full{
  min-width: 100% !important;
}
.\\!max-w-\\[240px\\]{
  max-width: 240px !important;
}
.max-w-\\[30rem\\]{
  max-width: 30rem !important;
}
.max-w-full{
  max-width: 100% !important;
}
.max-w-md{
  max-width: 28rem !important;
}
.max-w-screen-md{
  max-width: 768px !important;
}
.flex-shrink-0{
  flex-shrink: 0 !important;
}
.shrink-0{
  flex-shrink: 0 !important;
}
.flex-grow{
  flex-grow: 1 !important;
}
.-translate-x-1{
  --tw-translate-x: -0.25rem !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.-translate-x-full{
  --tw-translate-x: -100% !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.translate-x-0{
  --tw-translate-x: 0px !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.translate-x-1{
  --tw-translate-x: 0.25rem !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.-rotate-45{
  --tw-rotate: -45deg !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.rotate-45{
  --tw-rotate: 45deg !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.transform{
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
@keyframes spin{

  to{
    transform: rotate(360deg);
  }
}
.animate-spin{
  animation: spin 1s linear infinite !important;
}
.cursor-move{
  cursor: move !important;
}
.cursor-pointer{
  cursor: pointer !important;
}
.select-none{
  -webkit-user-select: none !important;
          user-select: none !important;
}
.resize{
  resize: both !important;
}
.list-inside{
  list-style-position: inside !important;
}
.list-none{
  list-style-type: none !important;
}
.grid-cols-1{
  grid-template-columns: repeat(1, minmax(0, 1fr)) !important;
}
.flex-row{
  flex-direction: row !important;
}
.flex-col{
  flex-direction: column !important;
}
.flex-wrap{
  flex-wrap: wrap !important;
}
.items-start{
  align-items: flex-start !important;
}
.items-end{
  align-items: flex-end !important;
}
.items-center{
  align-items: center !important;
}
.justify-start{
  justify-content: flex-start !important;
}
.justify-end{
  justify-content: flex-end !important;
}
.justify-center{
  justify-content: center !important;
}
.justify-between{
  justify-content: space-between !important;
}
.justify-evenly{
  justify-content: space-evenly !important;
}
.gap-1{
  gap: 0.25rem !important;
}
.gap-10{
  gap: 2.5rem !important;
}
.gap-2{
  gap: 0.5rem !important;
}
.gap-3{
  gap: 0.75rem !important;
}
.gap-4{
  gap: 1rem !important;
}
.gap-5{
  gap: 1.25rem !important;
}
.gap-6{
  gap: 1.5rem !important;
}
.gap-8{
  gap: 2rem !important;
}
.gap-\\[12px\\]{
  gap: 12px !important;
}
.gap-x-3{
  column-gap: 0.75rem !important;
}
.gap-y-3{
  row-gap: 0.75rem !important;
}
.space-y-2 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0 !important;
  margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse))) !important;
  margin-bottom: calc(0.5rem * var(--tw-space-y-reverse)) !important;
}
.space-y-4 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0 !important;
  margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse))) !important;
  margin-bottom: calc(1rem * var(--tw-space-y-reverse)) !important;
}
.overflow-hidden{
  overflow: hidden !important;
}
.overflow-x-auto{
  overflow-x: auto !important;
}
.overflow-y-auto{
  overflow-y: auto !important;
}
.overflow-x-hidden{
  overflow-x: hidden !important;
}
.overflow-x-scroll{
  overflow-x: scroll !important;
}
.rounded{
  border-radius: 0.25rem !important;
}
.rounded-\\[0\\.75rem\\]{
  border-radius: 0.75rem !important;
}
.rounded-\\[0\\.7rem\\]{
  border-radius: 0.7rem !important;
}
.rounded-\\[1\\.25rem\\]{
  border-radius: 1.25rem !important;
}
.rounded-\\[100\\%\\]{
  border-radius: 100% !important;
}
.rounded-\\[10px\\]{
  border-radius: 10px !important;
}
.rounded-full{
  border-radius: 9999px !important;
}
.rounded-lg{
  border-radius: 0.5rem !important;
}
.rounded-md{
  border-radius: 0.375rem !important;
}
.rounded-r-lg{
  border-top-right-radius: 0.5rem !important;
  border-bottom-right-radius: 0.5rem !important;
}
.border{
  border-width: 1px !important;
}
.border-2{
  border-width: 2px !important;
}
.border-b{
  border-bottom-width: 1px !important;
}
.border-b-2{
  border-bottom-width: 2px !important;
}
.border-l-2{
  border-left-width: 2px !important;
}
.border-r-2{
  border-right-width: 2px !important;
}
.border-t{
  border-top-width: 1px !important;
}
.border-t-2{
  border-top-width: 2px !important;
}
.border-none{
  border-style: none !important;
}
.border-\\[\\#ccc\\]{
  --tw-border-opacity: 1 !important;
  border-color: rgb(204 204 204 / var(--tw-border-opacity)) !important;
}
.border-danger{
  --tw-border-opacity: 1 !important;
  border-color: rgb(229 56 59 / var(--tw-border-opacity)) !important;
}
.border-gray-200{
  --tw-border-opacity: 1 !important;
  border-color: rgb(229 231 235 / var(--tw-border-opacity)) !important;
}
.border-indigo-100{
  --tw-border-opacity: 1 !important;
  border-color: rgb(224 231 255 / var(--tw-border-opacity)) !important;
}
.border-inherit{
  border-color: inherit !important;
}
.border-orange-500{
  --tw-border-opacity: 1 !important;
  border-color: rgb(249 115 22 / var(--tw-border-opacity)) !important;
}
.border-red-600{
  --tw-border-opacity: 1 !important;
  border-color: rgb(220 38 38 / var(--tw-border-opacity)) !important;
}
.border-rose-500{
  --tw-border-opacity: 1 !important;
  border-color: rgb(244 63 94 / var(--tw-border-opacity)) !important;
}
.border-slate-500{
  --tw-border-opacity: 1 !important;
  border-color: rgb(100 116 139 / var(--tw-border-opacity)) !important;
}
.border-slate-600{
  --tw-border-opacity: 1 !important;
  border-color: rgb(71 85 105 / var(--tw-border-opacity)) !important;
}
.bg-\\[\\#0e0d12\\]{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(14 13 18 / var(--tw-bg-opacity)) !important;
}
.bg-\\[\\#E5383B\\]{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(229 56 59 / var(--tw-bg-opacity)) !important;
}
.bg-\\[\\#F2F2F2\\]{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(242 242 242 / var(--tw-bg-opacity)) !important;
}
.bg-\\[\\#F5F4F4\\]{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(245 244 244 / var(--tw-bg-opacity)) !important;
}
.bg-\\[\\#f9fafb\\]{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity)) !important;
}
.bg-amber-500{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(245 158 11 / var(--tw-bg-opacity)) !important;
}
.bg-black{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity)) !important;
}
.bg-blue-100{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(219 234 254 / var(--tw-bg-opacity)) !important;
}
.bg-blue-500{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(59 130 246 / var(--tw-bg-opacity)) !important;
}
.bg-blue-600{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(37 99 235 / var(--tw-bg-opacity)) !important;
}
.bg-cyan-500{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(6 182 212 / var(--tw-bg-opacity)) !important;
}
.bg-cyan-700{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(14 116 144 / var(--tw-bg-opacity)) !important;
}
.bg-danger{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(229 56 59 / var(--tw-bg-opacity)) !important;
}
.bg-gray-100{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity)) !important;
}
.bg-gray-200{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(229 231 235 / var(--tw-bg-opacity)) !important;
}
.bg-gray-300{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(209 213 219 / var(--tw-bg-opacity)) !important;
}
.bg-gray-50{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity)) !important;
}
.bg-gray-500{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(107 114 128 / var(--tw-bg-opacity)) !important;
}
.bg-gray-700{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(55 65 81 / var(--tw-bg-opacity)) !important;
}
.bg-gray-900{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(17 24 39 / var(--tw-bg-opacity)) !important;
}
.bg-green-100{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(220 252 231 / var(--tw-bg-opacity)) !important;
}
.bg-green-500{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(34 197 94 / var(--tw-bg-opacity)) !important;
}
.bg-indigo-500{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(99 102 241 / var(--tw-bg-opacity)) !important;
}
.bg-inherit{
  background-color: inherit !important;
}
.bg-purple-500{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(168 85 247 / var(--tw-bg-opacity)) !important;
}
.bg-red-100{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(254 226 226 / var(--tw-bg-opacity)) !important;
}
.bg-red-700{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(185 28 28 / var(--tw-bg-opacity)) !important;
}
.bg-slate-600{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(71 85 105 / var(--tw-bg-opacity)) !important;
}
.bg-teal-500{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(20 184 166 / var(--tw-bg-opacity)) !important;
}
.bg-teal-600{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(13 148 136 / var(--tw-bg-opacity)) !important;
}
.bg-teal-700{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(15 118 110 / var(--tw-bg-opacity)) !important;
}
.bg-transparent{
  background-color: transparent !important;
}
.bg-violet-100{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(237 233 254 / var(--tw-bg-opacity)) !important;
}
.bg-violet-500{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(139 92 246 / var(--tw-bg-opacity)) !important;
}
.bg-violet-600{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(124 58 237 / var(--tw-bg-opacity)) !important;
}
.bg-white{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity)) !important;
}
.bg-opacity-80{
  --tw-bg-opacity: 0.8 !important;
}
.fill-white{
  fill: #fff !important;
}
.p-0{
  padding: 0px !important;
}
.p-1{
  padding: 0.25rem !important;
}
.p-2{
  padding: 0.5rem !important;
}
.p-3{
  padding: 0.75rem !important;
}
.p-4{
  padding: 1rem !important;
}
.p-5{
  padding: 1.25rem !important;
}
.p-6{
  padding: 1.5rem !important;
}
.p-8{
  padding: 2rem !important;
}
.px-1{
  padding-left: 0.25rem !important;
  padding-right: 0.25rem !important;
}
.px-10{
  padding-left: 2.5rem !important;
  padding-right: 2.5rem !important;
}
.px-2{
  padding-left: 0.5rem !important;
  padding-right: 0.5rem !important;
}
.px-3{
  padding-left: 0.75rem !important;
  padding-right: 0.75rem !important;
}
.px-4{
  padding-left: 1rem !important;
  padding-right: 1rem !important;
}
.px-5{
  padding-left: 1.25rem !important;
  padding-right: 1.25rem !important;
}
.px-6{
  padding-left: 1.5rem !important;
  padding-right: 1.5rem !important;
}
.px-8{
  padding-left: 2rem !important;
  padding-right: 2rem !important;
}
.px-9{
  padding-left: 2.25rem !important;
  padding-right: 2.25rem !important;
}
.py-1{
  padding-top: 0.25rem !important;
  padding-bottom: 0.25rem !important;
}
.py-2{
  padding-top: 0.5rem !important;
  padding-bottom: 0.5rem !important;
}
.py-3{
  padding-top: 0.75rem !important;
  padding-bottom: 0.75rem !important;
}
.py-4{
  padding-top: 1rem !important;
  padding-bottom: 1rem !important;
}
.py-5{
  padding-top: 1.25rem !important;
  padding-bottom: 1.25rem !important;
}
.py-8{
  padding-top: 2rem !important;
  padding-bottom: 2rem !important;
}
.pb-1{
  padding-bottom: 0.25rem !important;
}
.pb-2{
  padding-bottom: 0.5rem !important;
}
.pb-3{
  padding-bottom: 0.75rem !important;
}
.pb-6{
  padding-bottom: 1.5rem !important;
}
.pe-3{
  padding-inline-end: 0.75rem !important;
}
.pe-4{
  padding-inline-end: 1rem !important;
}
.pr-2{
  padding-right: 0.5rem !important;
}
.pr-3{
  padding-right: 0.75rem !important;
}
.ps-6{
  padding-inline-start: 1.5rem !important;
}
.pt-2{
  padding-top: 0.5rem !important;
}
.pt-4{
  padding-top: 1rem !important;
}
.pt-5{
  padding-top: 1.25rem !important;
}
.text-left{
  text-align: left !important;
}
.text-center{
  text-align: center !important;
}
.text-start{
  text-align: start !important;
}
.text-end{
  text-align: end !important;
}
.font-poppins{
  font-family: Poppins, sans-serif !important;
}
.text-2xl{
  font-size: 1.5rem !important;
  line-height: 2rem !important;
}
.text-3xl{
  font-size: 1.875rem !important;
  line-height: 2.25rem !important;
}
.text-4xl{
  font-size: 2.25rem !important;
  line-height: 2.5rem !important;
}
.text-5xl{
  font-size: 3rem !important;
  line-height: 1 !important;
}
.text-\\[10px\\]{
  font-size: 10px !important;
}
.text-\\[35px\\]{
  font-size: 35px !important;
}
.text-base{
  font-size: 1rem !important;
  line-height: 1.5rem !important;
}
.text-lg{
  font-size: 1.125rem !important;
  line-height: 1.75rem !important;
}
.text-sm{
  font-size: 0.875rem !important;
  line-height: 1.25rem !important;
}
.text-xl{
  font-size: 1.25rem !important;
  line-height: 1.75rem !important;
}
.text-xs{
  font-size: 0.75rem !important;
  line-height: 1rem !important;
}
.font-\\[600\\]{
  font-weight: 600 !important;
}
.font-bold{
  font-weight: 700 !important;
}
.font-extrabold{
  font-weight: 800 !important;
}
.font-medium{
  font-weight: 500 !important;
}
.font-normal{
  font-weight: 400 !important;
}
.font-semibold{
  font-weight: 600 !important;
}
.uppercase{
  text-transform: uppercase !important;
}
.capitalize{
  text-transform: capitalize !important;
}
.italic{
  font-style: italic !important;
}
.leading-7{
  line-height: 1.75rem !important;
}
.leading-normal{
  line-height: 1.5 !important;
}
.tracking-tight{
  letter-spacing: -0.025em !important;
}
.tracking-wider{
  letter-spacing: 0.05em !important;
}
.\\!text-black{
  --tw-text-opacity: 1 !important;
  color: rgb(0 0 0 / var(--tw-text-opacity)) !important;
}
.text-\\[\\#161A1D\\]{
  --tw-text-opacity: 1 !important;
  color: rgb(22 26 29 / var(--tw-text-opacity)) !important;
}
.text-\\[\\#1890ff\\]{
  --tw-text-opacity: 1 !important;
  color: rgb(24 144 255 / var(--tw-text-opacity)) !important;
}
.text-\\[\\#E5383B\\]{
  --tw-text-opacity: 1 !important;
  color: rgb(229 56 59 / var(--tw-text-opacity)) !important;
}
.text-\\[\\#EF4444\\]{
  --tw-text-opacity: 1 !important;
  color: rgb(239 68 68 / var(--tw-text-opacity)) !important;
}
.text-black{
  --tw-text-opacity: 1 !important;
  color: rgb(0 0 0 / var(--tw-text-opacity)) !important;
}
.text-blue-600{
  --tw-text-opacity: 1 !important;
  color: rgb(37 99 235 / var(--tw-text-opacity)) !important;
}
.text-danger{
  --tw-text-opacity: 1 !important;
  color: rgb(229 56 59 / var(--tw-text-opacity)) !important;
}
.text-gray-400{
  --tw-text-opacity: 1 !important;
  color: rgb(156 163 175 / var(--tw-text-opacity)) !important;
}
.text-gray-500{
  --tw-text-opacity: 1 !important;
  color: rgb(107 114 128 / var(--tw-text-opacity)) !important;
}
.text-gray-600{
  --tw-text-opacity: 1 !important;
  color: rgb(75 85 99 / var(--tw-text-opacity)) !important;
}
.text-gray-700{
  --tw-text-opacity: 1 !important;
  color: rgb(55 65 81 / var(--tw-text-opacity)) !important;
}
.text-gray-800{
  --tw-text-opacity: 1 !important;
  color: rgb(31 41 55 / var(--tw-text-opacity)) !important;
}
.text-gray-900{
  --tw-text-opacity: 1 !important;
  color: rgb(17 24 39 / var(--tw-text-opacity)) !important;
}
.text-green-500{
  --tw-text-opacity: 1 !important;
  color: rgb(34 197 94 / var(--tw-text-opacity)) !important;
}
.text-green-600{
  --tw-text-opacity: 1 !important;
  color: rgb(22 163 74 / var(--tw-text-opacity)) !important;
}
.text-indigo-500{
  --tw-text-opacity: 1 !important;
  color: rgb(99 102 241 / var(--tw-text-opacity)) !important;
}
.text-indigo-600{
  --tw-text-opacity: 1 !important;
  color: rgb(79 70 229 / var(--tw-text-opacity)) !important;
}
.text-indigo-700{
  --tw-text-opacity: 1 !important;
  color: rgb(67 56 202 / var(--tw-text-opacity)) !important;
}
.text-indigo-900{
  --tw-text-opacity: 1 !important;
  color: rgb(49 46 129 / var(--tw-text-opacity)) !important;
}
.text-red-500{
  --tw-text-opacity: 1 !important;
  color: rgb(239 68 68 / var(--tw-text-opacity)) !important;
}
.text-red-600{
  --tw-text-opacity: 1 !important;
  color: rgb(220 38 38 / var(--tw-text-opacity)) !important;
}
.text-rose-700{
  --tw-text-opacity: 1 !important;
  color: rgb(190 18 60 / var(--tw-text-opacity)) !important;
}
.text-slate-500{
  --tw-text-opacity: 1 !important;
  color: rgb(100 116 139 / var(--tw-text-opacity)) !important;
}
.text-violet-500{
  --tw-text-opacity: 1 !important;
  color: rgb(139 92 246 / var(--tw-text-opacity)) !important;
}
.text-violet-600{
  --tw-text-opacity: 1 !important;
  color: rgb(124 58 237 / var(--tw-text-opacity)) !important;
}
.text-white{
  --tw-text-opacity: 1 !important;
  color: rgb(255 255 255 / var(--tw-text-opacity)) !important;
}
.underline{
  text-decoration-line: underline !important;
}
.antialiased{
  -webkit-font-smoothing: antialiased !important;
  -moz-osx-font-smoothing: grayscale !important;
}
.opacity-10{
  opacity: 0.1 !important;
}
.shadow{
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1) !important;
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color) !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}
.shadow-sm{
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05) !important;
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color) !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}
.ring-1{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color) !important;
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color) !important;
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000) !important;
}
.ring-violet-300{
  --tw-ring-opacity: 1 !important;
  --tw-ring-color: rgb(196 181 253 / var(--tw-ring-opacity)) !important;
}
.ring-offset-2{
  --tw-ring-offset-width: 2px !important;
}
.ring-offset-violet-200{
  --tw-ring-offset-color: #ddd6fe !important;
}
.filter{
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow) !important;
}
.transition-all{
  transition-property: all !important;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
  transition-duration: 150ms !important;
}
.transition-colors{
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke !important;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
  transition-duration: 150ms !important;
}
.duration-150{
  transition-duration: 150ms !important;
}
.duration-300{
  transition-duration: 300ms !important;
}
.ease-out{
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1) !important;
}

html,
body {
	margin: 0;
	font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen",
		"Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue",
		sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
}

code {
	font-family: source-code-pro, Menlo, Monaco, Consolas, "Courier New",
		monospace;
}

.ant-btn-primary {
	background: #E5383B !important;
	border-color: #E5383B !important;
}

.ant-btn-primary:focus,
.ant-btn-primary:hover {
	background: #40a9ff !important;
}

.ant-table .ant-table-container .ant-table-content table thead.ant-table-thead {
	background-color: #f3f4f6 !important;
	color: black !important;
}

.ant-table-thead > tr > th {
	color: black !important;
	font-weight: 700;
	background-color: transparent;
	font-size: 13px;
}

.ant-layout-sider {
	color: #ffffff;
}

.ant-menu-item a {
	color:  #161A1D!important;
	padding: 0 10px;
	font-size: 16px !important;
	font-weight: 500 !important;
}

/* .ant-menu-item .active {
  background-color: #3a3a3a !important;
} */

.ant-picker-panels > *:first-child button.ant-picker-header-next-btn {
	visibility: visible !important;
}

.ant-picker-panels > *:first-child button.ant-picker-header-super-next-btn {
	visibility: visible !important;
}

.ant-picker-panels > *:last-child {
	display: none;
}

.ant-picker-panel-container,
.ant-picker-footer {
	width: 280px !important;
}

.ant-picker-footer-extra > div {
	flex-wrap: wrap !important;
}

.ant-card-head {
	min-height: 40px;
}
.table-card .ant-table-wrapper{
	border: 1px solid white;
	margin-top: 1rem !important;
}
.custom-filter-btn{
	background-color: #e40a0a !important;
	color:white;
	border: none;
}
.custom-filter-btn:hover,
.custom-filter-btn:focus{
	background-color: #F00000 !important;
	color:white !important;
}
 /* .franchise-card{
	box-shadow: 0 3px 10px rgb(0 0 0 / 0.2);
 } */
.franchise-form .ant-form-item-label{
	display: flex;
	justify-content: start;
	font-weight: 700 !important;
}
.franchise-form .ant-form-item-control input,
.franchise-form .ant-form-item-control textarea,
.franchise-form .ant-form-item-control select,
.franchise-form .ant-form-item-control .ant-select-selector,
.franchise-form .ant-input-status-error:not(.ant-input-disabled):not( .ant-input-borderless ).ant-input,
.franchise-form #fileInput{
    display: flex;
    padding-top: 10px !important;
    padding-bottom: 10px !important;
    align-items: center;
    gap: 4px;
    border-radius: 4px !important;
    /* border: none; */
    border: 0.5px solid #ccc !important;
	transition: border-color 0.2s ease;
    /* box-shadow: 0 3px 10px rgb(0 0 0 / 0.1); */
	color: #363131 !important;
	width: 100%;
}
.login-form .username-field,
.login-form #basic_password,
.login-form .ant-input-status-error:not(.ant-input-disabled):not( .ant-input-borderless ).ant-input{
	display: flex;
    padding-top: 10px !important;
    padding-bottom: 10px !important;
    align-items: center;
    gap: 4px;
    border-radius: 8px !important;
    border: 1px solid #202126 !important;
    background: #202126 !important;
    box-shadow: 0px 1px 2px 0px rgba(15, 23, 42, 0.06);
	color: white !important;
}
/* .card-wrapper table,.card-wrapper th,.card-wrapper td,
.role-wrapper table,.role-wrapper th,.role-wrapper td,
.table-card table,.table-card th,.table-card td,
.game-card table,.game-card th,.game-card td,
.ant-table-tbody > tr.ant-table-row-selected > td{
	border: 1px solid #0E0D12;
	border-collapse: collapse;
} */
.table-card .ant-checkbox {
	width: 18px;
	height: 18px;
	border: 1px solid #0E0D12;
	border-radius: 4px;
}
.login-wrapper .ant-card-body{
 	border-radius: 1.25rem;
	background-color: white !important;
}
 .sidebar-menu .ant-menu-submenu > .ant-menu,
 .sidebar-menu .ant-menu-submenu > .ant-menu a,
 .sidebar-menu .ant-menu:not(.ant-menu-horizontal) .ant-menu-item-selected,
 .ant-menu-item:active
 {
	background-color: white !important;
	color: #161A1D !important;
 }
 .sidebar-menu .ant-menu-submenu > .ant-menu > li:hover,
 .sidebar-menu .ant-menu-submenu > .ant-menu > li:hover a,
 .ant-menu-sub > .ant-menu-item a.active{
	background-color: #202126 !important;
 }
 .sidebar-menu .ant-menu-light .ant-menu-submenu-title:hover,
 .sidebar-menu .ant-menu-submenu-selected {
	color: white !important;
 }
 .sidebar-menu .ant-menu-submenu-title:active{
	background-color: #0e0d12 !important;
 }
 .page-height{
	min-height: 90vh !important;
}
.side-bar{
	position: fixed;
	left: 0;
	top: 64px;
	/* max-width: none !important; */
}
.ant-table-tbody > tr > td {
	border-bottom: 1px solid #0E0D12;
}
.role-wrapper .ant-select-multiple .ant-select-selection-item{
	border: none;
}
.stepper-wrapper {
	background-color: white;
	padding: 24px 24px 0 24px;
}
.login-page{
	margin-left: -200px !important;
	margin-top: -1rem !important;
}
.username-field .ant-input-suffix{
	margin-right: 10px !important;
}
.franchise-form #fileInput{
	padding-left: 10px !important;
}
.franchise-form .ant-select-show-search.ant-select:not(.ant-select-customize-input) .ant-select-selector{
	height: 44px !important;
}
/* .franchise-second-step, .franchise-third-step, .franchise-last-step, .franchise-card{
	box-shadow: 0 3px 10px rgb(0 0 0 / 0.2);
} */
.ant-drawer-content-wrapper .ant-form-vertical input,.franchise-search-input,.upload-input .ant-btn{
	border: 0.8px solid #bbbbbb;
}
.ant-drawer-content-wrapper .ant-form-vertical .ant-form-item-label > label{
	font-weight: 600;
}
.card-wrapper .ant-select-selection-item,
.game-card .ant-select-selection-item,
.table-card .ant-select-selection-item{
	border: none;
}
input#quoteDate{
	border: none;
}
.ant-steps-item-process > .ant-steps-item-container > .ant-steps-item-icon {
    background: #FFCDCB;
	border: 1px solid #E5383B;
	color: #E5383B !important;
}
.ant-steps-item-process > .ant-steps-item-container > .ant-steps-item-icon > span {
	color: #E5383B !important;
}
#end_date,#start_date,#bookingDate,
#end_date:hover,#start_date:hover,#bookingDate:hover{
	border: none !important;
}
.form-item-alignment .ant-row {
	flex-direction: column;
	gap: 2px;
}
.form-item-alignment .ant-form-item-required {
	display: flex;
	flex-direction: row-reverse;
	gap:2px;
}
.form-item-alignment .ant-form-item-required::after,
.form-item-alignment .ant-form-item-label > label::after {
	display: none;
}

.stepper-wrapper .ant-steps-item-finish .ant-steps-item-icon {
    border-color:#e40a0a;
}
.stepper-wrapper .anticon {
    color: #e40a0a;
}
.stepper-wrapper .ant-steps-item-finish > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-title::after,
.stepper-wrapper .ant-steps-item-finish > .ant-steps-item-container > .ant-steps-item-tail::after {
    background-color: #e40a0a;
}
.franchise-second-step label{
	font-weight: 600;
}
.ant-drawer-title,.ant-drawer-close svg{
	font-size: 18px;
	font-weight: 600;
}

.slot-grid .ant-table-thead > tr > th,
.franchise-last-step .ant-table-thead > tr > th,
.slot-grid .ant-table-tbody > tr > td,
.franchise-last-step .ant-table-tbody > tr > td {
    border:none !important;
	vertical-align: initial !important;
}
.side-bar .ant-layout-sider-trigger{
	display: none;
}
.ant-drawer-content-wrapper .ant-drawer-body {
	overflow-x: hidden;
}
.franchise-days-section .franchise-time{
	height: 44px;
}
.franchise-days-section .franchise-time input{
	border: none !important;
}
.franchise-form .buffer-time input{
	border: none !important;
}
.franchise-form .buffer-time .ant-form-item-control-input-content .ant-input-number{
	display: flex;
	align-items: center;
	height: 44px;
}
.time-wrapper {
	border: 0.8px solid #bbbbbb;
	border-radius: 4px !important;
}
.franchise-form .ant-form-item-label{
	width: 100% !important;
}
.table-card .ant-select-selection-item-content,
.card-wrapper .ant-select-selection-item-content{
	font-size: 12px;
}
@media screen and (min-width:768px){
	.table-card .ant-select-selection-item-content,
	.card-wrapper .ant-select-selection-item-content{
		font-size: 14px !important;
	}
}
.stepper-wrapper{
	display: flex !important;
	flex-wrap: wrap;
	flex-direction: row;
	gap: 8px;
}
.stepper-wrapper .ant-steps-item{
	display: flex;
}
.stepper-wrapper .ant-steps-item.ant-steps-item-active{
	width: max-content;
}
.stepper-wrapper .ant-steps-item.ant-steps-item-active .ant-steps-item-description,
.stepper-wrapper .ant-steps-item .ant-steps-item-description{
	display: none;
}
.stepper-wrapper .ant-steps-item.ant-steps-item-active .ant-steps-item-title{
	font-size: 14px;
	padding-right: 4px;
}
.ant-steps-vertical > .ant-steps-item .ant-steps-item-icon{
	margin-top: 4px;
}
.ant-steps-item-wait .ant-steps-item-content,
.ant-steps-item-finish .ant-steps-item-content{
	display: none !important;
}
.ant-steps-vertical > .ant-steps-item .ant-steps-item-icon {
	margin-right: 8px;
	display: flex;
	align-items: center;
	justify-content: center;
}
.franchise-form .franchise-days-section .ant-select-show-search.ant-select:not(.ant-select-customize-input) .ant-select-selector {
    height: 76px !important;
	padding-top: 0 !important;
	padding-bottom: 0 !important;
}
.stepper-wrapper .ant-steps-item-icon {
    width: 24px;
    height: 24px;
    margin: 0 8px 0 0;
    font-size: 12px;
}
.ant-steps-item-finish .ant-steps-icon{
	display: flex;
	align-items: center;
	justify-content: center;
}
/* .franchise-last-step table,.franchise-last-step th,.franchise-last-step tr,.franchise-last-step td,
.franchise-third-step table,.franchise-third-step th,.franchise-third-step tr,.franchise-third-step td{
	border: 1px solid;
	border-collapse: collapse;
} */
.franchise-third-step .ant-table-content{
	overflow-x: scroll;
}
.sidebar-menu .ant-menu:not(.ant-menu-horizontal) .ant-menu-item-selected span a span{
	color: #E5383B !important;
	font-weight: 600;
}
.ant-menu-inline .ant-menu-item::after {
	border-right: 5px solid #E5383B !important;
    border-radius: 3px;
}
.btn-primary{
 background-color: #E5383B !important;
 border-radius: 1.25rem !important;
 color: white !important;
 font-weight: 500;
}
.btn-primary:hover{
	background-color: #e61013 !important;
}
.btn-secondary{
	background-color: #FFCDCB !important;
	border-radius: 1.25rem !important;
	color: #E5383B !important;
	border: 1px solid #E5383B;
	font-weight: 600;
	padding: 4px 16px !important;
}
.btn-secondary:hover{
	border: 1px solid #E5383B !important;
}
.card-custom{
	background-color: transparent !important;
}
.border-radius-top{
	border-radius: 16px 16px 0 0 !important;
}
.border-radius-bottom{
	border-radius: 0 0 16px 16px !important;
}
.min-h-screen.ant-layout {
	background-color: #F3EDE8 !important;
}
.ant-steps-vertical > .ant-steps-item > .ant-steps-item-container > .ant-steps-item-tail::after{
	width:20px;
	height: 1.5px !important;
}
.ant-steps-vertical > .ant-steps-item > .ant-steps-item-container > .ant-steps-item-tail {
    position: absolute;
    top: -22px;
    left: 30px;
    width: 100px;
    height: 100%;
    padding: 38px 0 6px;
}
.table-top-padding{
	padding:24px 24px 0px 24px;
}
.table-inner-padding{
	padding:0 24px 24px 24px;
}
.ant-input-search > .ant-input-group > .ant-input-group-addon:last-child {
	left: -3px;
}
.ant-table-thead > tr > th {
	color: white !important;
	border: none;
	background-color: #27272A !important;

}
.ant-table-thead > tr > th:first-child,
.ant-table-tbody > tr >td:first-child{
	border-radius: 12px 0 0 12px !important;
}
.odd-row{
	background-color: #F2F2F2 !important;
}
.ant-table-tbody > tr > td {
	border-bottom: none;
}
.ant-table-thead > tr > th:not(:last-child):not(.ant-table-selection-column):not(.ant-table-row-expand-icon-cell):not([colspan])::before {
	background-color: #464648 !important;
}
.ant-pagination-item-active{
	background-color: #FFCDCB !important;
	color: #E5383B !important;
	border: 1px solid #E5383B;
	border-radius: 12px;
}
.ant-pagination-item-active a{
	color: #E5383B;
}
.ant-input-search .ant-input:hover,
.ant-input-search .ant-input:focus{
	border-color: #d9d9d9 !important;
	box-shadow: 0 0 0 2px rgb(255 24 33 / 20%);
}
.ant-select-show-search.ant-select:not(.ant-select-customize-input).column-selector .ant-select-selector{
	height: 30px !important;
	border: 1px solid #bbbbbb !important;
	border-radius: 0.5rem !important;
}
.column-selector .ant-select-selector .ant-select-selection-item-content{
	font-size: 11px;
}
.ant-spin-container{
	display: flex;
	flex-direction: column;
	align-items: normal;

}
.ant-pagination{
	align-self: flex-end;
	padding: 4px 8px;
    background: #F2F2F2;
    border-radius: 8px;
}
.ant-pagination .ant-pagination-prev button,
.ant-pagination .ant-pagination-next button{
	border: none !important;
	background: none !important;
	background-color: transparent !important;
}
.ant-pagination-item:hover ,.ant-pagination-item-active:hover {
	border-color: #DD0707 !important;
}
.ant-pagination-item:hover a,
.ant-pagination-item-active:hover a{
	color: #DD0707;
}
.stepper-wrapper .ant-steps-item-container {
	cursor: pointer;
}
.ant-drawer-header-title {
    flex-direction: row-reverse;
}
.btn-tertiary{
	border: 1px solid #E5383B !important;
	border-radius: 1.25rem !important;
	color: #E5383B !important;
	background-color: white !important;
}
.ant-select:not(.ant-select-customize-input) .ant-select-selector,.ant-picker {
	border: 0.8px solid #bbbbbb;
}
.ant-picker:hover,
.franchise-form .ant-form-item-control input:hover,
.ant-picker-focused,
.ant-input:focus,
.ant-input:hover,
.ant-form-item-control textarea:hover,
.ant-form-item-control input:hover,
.time-wrapper:hover {
	border: 0.8px solid #010000 !important;
	box-shadow: none !important;
}
.ant-pagination-item{
	border-radius: 12px;
}
.ant-select:not(.ant-select-disabled):hover .ant-select-selector,
.ant-input-number:hover {
	border: 0.8px solid #010000 !important;
    border-right-width: 0;
}
.username .ant-form-item-label,.password .ant-form-item-label{
	align-self: flex-start;
}
.username .ant-form-item-label label,
.password .ant-form-item-label label{
	color: #111827;
	font-weight: 500;
}
.password .ant-input-affix-wrapper:not(.ant-input-affix-wrapper-disabled):hover {
    border-color: #010000 !important;
    border-right-width: 1px;
    z-index: 1;
}
.pass-field .ant-input:hover {
	border: none !important;
    box-shadow: none !important;
}
.pass-field .ant-input{
	background-color: #f9fafb !important;
	border-radius: 0.75rem 0 0 0.75rem !important;
}
.time-wrapper .start-time,
.time-wrapper #start-time input,
.time-wrapper #end-time input,
.time-wrapper .end-time,
.ant-picker.ant-picker-small#start-time:hover,
.ant-picker.ant-picker-small#end-time:hover,
.start-time .ant-picker-focused,
.end-time .ant-picker-focused,
.franchise-third-step .ant-input-number-input,
.franchise-third-step .ant-input-number-input:hover,
.franchise-last-step .ant-input-number-input:hover,
.franchise-last-step .ant-input-number-input
{
	border: none !important;
	box-shadow: none !important;
}

.time-wrapper .start-time #start-time,
.time-wrapper .end-time #end-time,
.date-picker .ant-picker-input input,
.date-picker .ant-picker-input input:hover{
	border: none !important;
}
.ant-picker-active-bar{
	display: none;
}
.ant-pagination-prev.ant-pagination-disabled button span svg,
.ant-pagination-next.ant-pagination-disabled button span svg{
	color: #ada7a7;
}
.password .ant-col-24.ant-form-item-label,
.username .ant-col-24.ant-form-item-label{
	padding: 0 0 0;
}
.ant-select-item-option-selected,
.ant-picker-time-panel-column > li.ant-picker-time-panel-cell-selected .ant-picker-time-panel-cell-inner  {
	background-color: #f8e1e1 !important;
}
.ant-select-item-option-active:not(.ant-select-item-option-disabled)
{
	background-color: #FFCDCB !important;
}
.ant-select-item-option-selected:not(.ant-select-item-option-disabled) .ant-select-item-option-state {
	color: #E5383B !important;
}
.ant-picker-cell-in-view.ant-picker-cell-selected .ant-picker-cell-inner{
	background-color: #E5383B !important;
}
.ant-select-multiple.ant-select-sm .ant-select-selection-item {
	background-color: #FFCDCB !important;
	border-radius: 1.25rem !important;
	color: #E5383B !important;
	border: 0.8px solid #E5383B;
	padding: 0px 10px !important;
	font-size: 12px !important;
	height: 20px !important;
}
.franchise-days-section .anticon.anticon-close{
	color: #E5383B;
}
.ant-checkbox-checked::after {
	border:1px solid #E5383B !important;
}
.ant-checkbox-checked .ant-checkbox-inner {
	background-color: #E5383B;
    border-color: #E5383B;
}
.ant-checkbox-wrapper:hover .ant-checkbox-inner,
.ant-checkbox:hover .ant-checkbox-inner,
.ant-checkbox-input:focus + .ant-checkbox-inner {
	border-color: #E5383B !important;
}
.ant-pagination-options{
	display: flex;
	align-items: center;
}
.ant-pagination-options .ant-select-single:not(.ant-select-customize-input) .ant-select-selector {
	width: 100%;
    height: 26px;
    padding: 0 10px;
	background-color: transparent !important;
}
.ant-select-selection-item{
	display: flex;
	align-items: center;
	font-size: 12px;
}
.ant-pagination-options .ant-select-arrow{
	font-size: 9px;
}
.ant-pagination-options .ant-select-single.ant-select-show-arrow .ant-select-selection-item{
	padding-right: 16px;
}
.ant-table-tbody > tr > .ant-table-cell{
	padding-top: 0.4rem !important;
    padding-bottom: 0.4rem !important;
}
.ant-table-thead>tr>th {
	padding: 12px 12px !important;
}
input#basic_password:focus{
	border: none !important;
}
.pass-field.ant-input-affix-wrapper:focus,
.pass-field.ant-input-affix-wrapper-focused,
.upload-input .ant-btn:hover,
.upload-input .ant-btn:focus,
.upload-input .ant-btn:active,
.ant-input-number:focus,
.ant-input-number-focused {
    border-color: #010000 !important;
    box-shadow: none !important;
    border-right-width: 1px;
    outline: 0;
}
.franchise-sts .ant-select-selector{
	height: 44px !important;
}
.ant-input::placeholder,
input::placeholder,
select::placeholder,
.ant-select-selector::placeholder,
.ant-select-selection-placeholder{
	color: #a59f9f !important;
}
.ant-drawer-content-wrapper label{
	display: flex;
    gap: 2px;
    justify-content: start;
}
.ant-form-item-label > label.ant-form-item-required:not(.ant-form-item-required-mark-optional)::before {
	order: 3;
}
.difficulty-level .ant-select-selector{
	height: 35px;
	display: flex;
	align-items: start;
}
.common-search-input{
	border: 1px solid #bbbbbb !important;
	border-radius: 0.5rem !important;
}
.common-search-input:hover {
	border: 0.8px solid #010000 !important;
}
.common-search-input:focus,.common-search-input.ant-input-affix-wrapper-focused{
	border: 0.8px solid #010000 !important;
	box-shadow: none !important;
}
.common-search-input input{
	border: none !important;
	border-radius: 0.5rem !important;
}
.common-search-input input:focus,
.common-search-input input:hover{
	border: none !important;
	box-shadow: none !important;
}
.plus-icon{
	width: 14px;
	height: 14px;
}
.plus-icon path{
	stroke-width: 1px;
}
.ant-table-cell-scrollbar:not([rowspan]){
	box-shadow: none !important;
}
.ant-modal-content,.ant-modal-header {
	border-radius: 16px;

}
.ant-modal-title{
	font-weight: 600;
}
.ant-modal-footer{
	padding-bottom: 20px
}
@media screen and (max-width:414px){
	.ant-table-tbody > tr > .ant-table-cell {
		padding-top: 0.2rem !important;
		padding-bottom: 0.2rem !important;
	}
	.ant-table-thead>tr>th {
		padding: 8px 12px !important;
	}
	.common-search-input input{
		padding: 3px 10px !important;
	}
}
@media screen and (min-width:768px){
	.stepper-wrapper .ant-steps-item .ant-steps-item-icon{
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.stepper-wrapper .ant-steps-item-container{
		display: flex;
		align-items: center;
	}
	.ant-steps-item-wait .ant-steps-item-content,
	.ant-steps-item-finish .ant-steps-item-content{
		display: inline-block !important;
	}
	.stepper-wrapper .ant-steps-item .ant-steps-item-title {
		font-size: 14px;
	}
	.ant-steps-vertical > .ant-steps-item:not(:last-child) > .ant-steps-item-container > .ant-steps-item-tail{
		display: block;
	}
	.column-selector .ant-select-selector .ant-select-selection-item-content{
		font-size: 14px;
	}
	.stepper-wrapper .ant-steps-item .ant-steps-item-title{
		font-weight: 600;
	}
	.plus-icon{
		width: 16px;
		height: 16px;
	}
	.plus-icon path{
		stroke-width: 2px;
	}
}
@media screen and (min-width:1220px){
	.stepper-wrapper .ant-steps-item.ant-steps-item-active .ant-steps-item-description,
	.stepper-wrapper .ant-steps-item .ant-steps-item-description{
		display: flex;
	}
	.stepper-wrapper .ant-steps-item .ant-steps-item-description{
		font-weight: 400;
		font-size: 12px;
		line-height: 1.3;
	}
	.stepper-wrapper .ant-steps-item-icon {
		width: 32px;
		height: 32px;
		margin: 0 12px 0 0;
		font-size: 12px;
	}
	.stepper-wrapper .ant-steps-item-container {
		align-items: start !important;
	}
	.stepper-wrapper .ant-steps-item.ant-steps-item-active .ant-steps-item-title,
	.stepper-wrapper .ant-steps-item .ant-steps-item-title{
		font-size: 16px;
	}
}
.file\\:mb-0::file-selector-button{
  margin-bottom: 0px !important;
}
.file\\:ml-4::file-selector-button{
  margin-left: 1rem !important;
}
.file\\:mr-4::file-selector-button{
  margin-right: 1rem !important;
}
.file\\:mt-0::file-selector-button{
  margin-top: 0px !important;
}
.file\\:rounded-full::file-selector-button{
  border-radius: 9999px !important;
}
.file\\:border-0::file-selector-button{
  border-width: 0px !important;
}
.file\\:bg-blue-50::file-selector-button{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(239 246 255 / var(--tw-bg-opacity)) !important;
}
.file\\:px-4::file-selector-button{
  padding-left: 1rem !important;
  padding-right: 1rem !important;
}
.file\\:py-2::file-selector-button{
  padding-top: 0.5rem !important;
  padding-bottom: 0.5rem !important;
}
.file\\:text-sm::file-selector-button{
  font-size: 0.875rem !important;
  line-height: 1.25rem !important;
}
.file\\:font-semibold::file-selector-button{
  font-weight: 600 !important;
}
.file\\:text-blue-700::file-selector-button{
  --tw-text-opacity: 1 !important;
  color: rgb(29 78 216 / var(--tw-text-opacity)) !important;
}
.hover\\:cursor-pointer:hover{
  cursor: pointer !important;
}
.hover\\:\\!border-\\[\\#d9d9d9\\]:hover{
  --tw-border-opacity: 1 !important;
  border-color: rgb(217 217 217 / var(--tw-border-opacity)) !important;
}
.hover\\:border-\\[\\#E5383B\\]:hover{
  --tw-border-opacity: 1 !important;
  border-color: rgb(229 56 59 / var(--tw-border-opacity)) !important;
}
.hover\\:bg-\\[\\#F2F2F2\\]:hover{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(242 242 242 / var(--tw-bg-opacity)) !important;
}
.hover\\:bg-\\[\\#FFCDCB\\]:hover{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(255 205 203 / var(--tw-bg-opacity)) !important;
}
.hover\\:bg-amber-700:hover{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(180 83 9 / var(--tw-bg-opacity)) !important;
}
.hover\\:bg-blue-600:hover{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(37 99 235 / var(--tw-bg-opacity)) !important;
}
.hover\\:bg-blue-700:hover{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(29 78 216 / var(--tw-bg-opacity)) !important;
}
.hover\\:bg-cyan-500:hover{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(6 182 212 / var(--tw-bg-opacity)) !important;
}
.hover\\:bg-cyan-700:hover{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(14 116 144 / var(--tw-bg-opacity)) !important;
}
.hover\\:bg-dangerHover:hover{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(221 7 7 / var(--tw-bg-opacity)) !important;
}
.hover\\:bg-emerald-500:hover{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(16 185 129 / var(--tw-bg-opacity)) !important;
}
.hover\\:bg-gray-100:hover{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity)) !important;
}
.hover\\:bg-gray-500:hover{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(107 114 128 / var(--tw-bg-opacity)) !important;
}
.hover\\:bg-indigo-500:hover{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(99 102 241 / var(--tw-bg-opacity)) !important;
}
.hover\\:bg-indigo-700:hover{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(67 56 202 / var(--tw-bg-opacity)) !important;
}
.hover\\:bg-purple-700:hover{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(126 34 206 / var(--tw-bg-opacity)) !important;
}
.hover\\:bg-rose-500:hover{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(244 63 94 / var(--tw-bg-opacity)) !important;
}
.hover\\:bg-slate-500:hover{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(100 116 139 / var(--tw-bg-opacity)) !important;
}
.hover\\:bg-teal-500:hover{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(20 184 166 / var(--tw-bg-opacity)) !important;
}
.hover\\:bg-teal-700:hover{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(15 118 110 / var(--tw-bg-opacity)) !important;
}
.hover\\:bg-violet-500:hover{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(139 92 246 / var(--tw-bg-opacity)) !important;
}
.hover\\:bg-violet-700:hover{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(109 40 217 / var(--tw-bg-opacity)) !important;
}
.hover\\:\\!text-black:hover{
  --tw-text-opacity: 1 !important;
  color: rgb(0 0 0 / var(--tw-text-opacity)) !important;
}
.hover\\:text-dangerHover:hover{
  --tw-text-opacity: 1 !important;
  color: rgb(221 7 7 / var(--tw-text-opacity)) !important;
}
.hover\\:text-indigo-100:hover{
  --tw-text-opacity: 1 !important;
  color: rgb(224 231 255 / var(--tw-text-opacity)) !important;
}
.hover\\:text-indigo-300:hover{
  --tw-text-opacity: 1 !important;
  color: rgb(165 180 252 / var(--tw-text-opacity)) !important;
}
.hover\\:text-rose-100:hover{
  --tw-text-opacity: 1 !important;
  color: rgb(255 228 230 / var(--tw-text-opacity)) !important;
}
.hover\\:text-white:hover{
  --tw-text-opacity: 1 !important;
  color: rgb(255 255 255 / var(--tw-text-opacity)) !important;
}
.hover\\:ring-offset-violet-500:hover{
  --tw-ring-offset-color: #8b5cf6 !important;
}
.hover\\:file\\:bg-blue-100::file-selector-button:hover{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(219 234 254 / var(--tw-bg-opacity)) !important;
}
.focus\\:\\!border-\\[\\#d9d9d9\\]:focus{
  --tw-border-opacity: 1 !important;
  border-color: rgb(217 217 217 / var(--tw-border-opacity)) !important;
}
.focus\\:border-\\[\\#40a9ff\\]:focus{
  --tw-border-opacity: 1 !important;
  border-color: rgb(64 169 255 / var(--tw-border-opacity)) !important;
}
.focus\\:\\!text-black:focus{
  --tw-text-opacity: 1 !important;
  color: rgb(0 0 0 / var(--tw-text-opacity)) !important;
}
.focus\\:shadow-none:focus{
  --tw-shadow: 0 0 #0000 !important;
  --tw-shadow-colored: 0 0 #0000 !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}
.focus\\:outline-none:focus{
  outline: 2px solid transparent !important;
  outline-offset: 2px !important;
}
.focus\\:ring-0:focus{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color) !important;
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color) !important;
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000) !important;
}
.focus-visible\\:outline-none:focus-visible{
  outline: 2px solid transparent !important;
  outline-offset: 2px !important;
}
.disabled\\:bg-gray-400:disabled{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(156 163 175 / var(--tw-bg-opacity)) !important;
}
.disabled\\:opacity-50:disabled{
  opacity: 0.5 !important;
}
.group:hover .group-hover\\:flex{
  display: flex !important;
}
.group:hover .group-hover\\:translate-x-0{
  --tw-translate-x: 0px !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
:is(.dark .dark\\:border-gray-700){
  --tw-border-opacity: 1 !important;
  border-color: rgb(55 65 81 / var(--tw-border-opacity)) !important;
}
:is(.dark .dark\\:bg-DTableBg){
  --tw-bg-opacity: 1 !important;
  background-color: rgb(46 45 53 / var(--tw-bg-opacity)) !important;
}
:is(.dark .dark\\:bg-gray-700){
  --tw-bg-opacity: 1 !important;
  background-color: rgb(55 65 81 / var(--tw-bg-opacity)) !important;
}
:is(.dark .dark\\:bg-gray-800){
  --tw-bg-opacity: 1 !important;
  background-color: rgb(31 41 55 / var(--tw-bg-opacity)) !important;
}
:is(.dark .dark\\:text-gray-100){
  --tw-text-opacity: 1 !important;
  color: rgb(243 244 246 / var(--tw-text-opacity)) !important;
}
:is(.dark .dark\\:text-gray-400){
  --tw-text-opacity: 1 !important;
  color: rgb(156 163 175 / var(--tw-text-opacity)) !important;
}
:is(.dark .dark\\:text-white){
  --tw-text-opacity: 1 !important;
  color: rgb(255 255 255 / var(--tw-text-opacity)) !important;
}
@media (min-width: 576px){

  .sm\\:flex-row{
    flex-direction: row !important;
  }

  .sm\\:items-center{
    align-items: center !important;
  }

  .sm\\:justify-start{
    justify-content: flex-start !important;
  }

  .sm\\:justify-end{
    justify-content: flex-end !important;
  }

  .sm\\:gap-2{
    gap: 0.5rem !important;
  }

  .sm\\:gap-\\[12px\\]{
    gap: 12px !important;
  }

  .sm\\:text-4xl{
    font-size: 2.25rem !important;
    line-height: 2.5rem !important;
  }
}
@media (min-width: 768px){

  .md\\:col-span-1{
    grid-column: span 1 / span 1 !important;
  }

  .md\\:ml-5{
    margin-left: 1.25rem !important;
  }

  .md\\:block{
    display: block !important;
  }

  .md\\:flex{
    display: flex !important;
  }

  .md\\:hidden{
    display: none !important;
  }

  .md\\:h-\\[calc\\(100vh-400px\\)\\]{
    height: calc(100vh - 400px) !important;
  }

  .md\\:w-1\\/2{
    width: 50% !important;
  }

  .md\\:w-4\\/5{
    width: 80% !important;
  }

  .md\\:w-\\[160px\\]{
    width: 160px !important;
  }

  .md\\:w-\\[180px\\]{
    width: 180px !important;
  }

  .md\\:w-\\[250px\\]{
    width: 250px !important;
  }

  .md\\:w-auto{
    width: auto !important;
  }

  .md\\:w-max{
    width: max-content !important;
  }

  .md\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
  }

  .md\\:flex-row{
    flex-direction: row !important;
  }

  .md\\:items-center{
    align-items: center !important;
  }

  .md\\:justify-end{
    justify-content: flex-end !important;
  }

  .md\\:justify-between{
    justify-content: space-between !important;
  }

  .md\\:gap-0{
    gap: 0px !important;
  }

  .md\\:px-6{
    padding-left: 1.5rem !important;
    padding-right: 1.5rem !important;
  }

  .md\\:px-8{
    padding-left: 2rem !important;
    padding-right: 2rem !important;
  }

  .md\\:pl-5{
    padding-left: 1.25rem !important;
  }

  .md\\:pr-3{
    padding-right: 0.75rem !important;
  }

  .md\\:text-2xl{
    font-size: 1.5rem !important;
    line-height: 2rem !important;
  }

  .md\\:text-\\[14px\\]{
    font-size: 14px !important;
  }
}
@media (min-width: 992px){

  .lg\\:ms-\\[-240px\\]{
    margin-inline-start: -240px !important;
  }

  .lg\\:ms-\\[240px\\]{
    margin-inline-start: 240px !important;
  }

  .lg\\:mt-0{
    margin-top: 0px !important;
  }

  .lg\\:block{
    display: block !important;
  }

  .lg\\:hidden{
    display: none !important;
  }

  .lg\\:h-screen{
    height: 100vh !important;
  }

  .lg\\:w-1\\/3{
    width: 33.333333% !important;
  }

  .lg\\:items-center{
    align-items: center !important;
  }

  .lg\\:px-6{
    padding-left: 1.5rem !important;
    padding-right: 1.5rem !important;
  }

  .lg\\:text-2xl{
    font-size: 1.5rem !important;
    line-height: 2rem !important;
  }
}
@media (min-width: 1200px){

  .xl\\:w-\\[50\\%\\]{
    width: 50% !important;
  }

  .xl\\:grid-cols-4{
    grid-template-columns: repeat(4, minmax(0, 1fr)) !important;
  }

  .xl\\:px-10{
    padding-left: 2.5rem !important;
    padding-right: 2.5rem !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAEA;;CAAc;;AAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;CAAc;;AAAd;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc,EAAd,MAAc;EAAd,WAAc,EAAd,MAAc;EAAd,4NAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,yCAAc;UAAd,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;EAAA,wCAAc;CAAA;;AAAd,gCAAc;;AAAd;;EAAA,wBAAc;EAAd,SAAc;EAAd,WAAc;CAAA;;AAAd,YAAc;;AAAd;EAAA,0BAAc;CAAA;;AAAd;EAAA,oBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd;AAAc;AACd;EAAA,WAAoB;EAApB,kBAAoB;EAApB,iBAAoB;EAApB,mBAAoB;EAApB;AAAoB;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAiCnB;EACC,qEAAqE;CACtE;AAEA;EACC,sEAAsE;CACvE;AAEA;EACC,wEAAwE;CACzE;AA1CD;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kCAAmB;EAAnB;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,oCAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oCAAmB;UAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kCAAmB;EAAnB,yEAAmB;EAAnB;AAAmB;AAAnB;EAAA,kCAAmB;EAAnB,uEAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,8CAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qFAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,qDAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sHAAmB;EAAnB,oHAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,mCAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,0GAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;;AA6CnB;;CAEC,SAAS;CACT;;YAEW;CACX,mCAAmC;CACnC,kCAAkC;AACnC;;AAEA;CACC;WACU;AACX;;AAEA;CACC,8BAA8B;CAC9B,gCAAgC;AACjC;;AAEA;;CAEC,8BAA8B;AAC/B;;AAEA;CACC,oCAAoC;CACpC,uBAAuB;AACxB;;AAEA;CACC,uBAAuB;CACvB,gBAAgB;CAChB,6BAA6B;CAC7B,eAAe;AAChB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,yBAAyB;CACzB,eAAe;CACf,0BAA0B;CAC1B,2BAA2B;AAC5B;;AAEA;;GAEG;;AAEH;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,aAAa;AACd;;AAEA;;CAEC,uBAAuB;AACxB;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,gBAAgB;AACjB;AACA;CACC,uBAAuB;CACvB,2BAA2B;AAC5B;AACA;CACC,oCAAoC;CACpC,WAAW;CACX,YAAY;AACb;AACA;;CAEC,oCAAoC;CACpC,sBAAsB;AACvB;CACC;;IAEG;AACJ;CACC,aAAa;CACb,sBAAsB;CACtB,2BAA2B;AAC5B;AACA;;;;;;IAMI,aAAa;IACb,4BAA4B;IAC5B,+BAA+B;IAC/B,mBAAmB;IACnB,QAAQ;IACR,6BAA6B;IAC7B,kBAAkB;IAClB,mCAAmC;CACtC,kCAAkC;IAC/B,6CAA6C;CAChD,yBAAyB;CACzB,WAAW;AACZ;AACA;;;CAGC,aAAa;IACV,4BAA4B;IAC5B,+BAA+B;IAC/B,mBAAmB;IACnB,QAAQ;IACR,6BAA6B;IAC7B,oCAAoC;IACpC,8BAA8B;IAC9B,kDAAkD;CACrD,uBAAuB;AACxB;AACA;;;;;;;GAOG;AACH;CACC,WAAW;CACX,YAAY;CACZ,yBAAyB;CACzB,kBAAkB;AACnB;AACA;EACE,sBAAsB;CACvB,kCAAkC;AACnC;CACC;;;;;CAKA,kCAAkC;CAClC,yBAAyB;CACzB;CACA;;;CAGA,oCAAoC;CACpC;CACA;;CAEA,uBAAuB;CACvB;CACA;CACA,oCAAoC;CACpC;CACA;CACA,2BAA2B;AAC5B;AACA;CACC,eAAe;CACf,OAAO;CACP,SAAS;CACT,gCAAgC;AACjC;AACA;CACC,gCAAgC;AACjC;AACA;CACC,YAAY;AACb;AACA;CACC,uBAAuB;CACvB,yBAAyB;AAC1B;AACA;CACC,8BAA8B;CAC9B,4BAA4B;AAC7B;AACA;CACC,6BAA6B;AAC9B;AACA;CACC,6BAA6B;AAC9B;AACA;CACC,uBAAuB;AACxB;AACA;;GAEG;AACH;CACC,2BAA2B;AAC5B;AACA;CACC,gBAAgB;AACjB;AACA;;;CAGC,YAAY;AACb;AACA;CACC,YAAY;AACb;AACA;IACI,mBAAmB;CACtB,yBAAyB;CACzB,yBAAyB;AAC1B;AACA;CACC,yBAAyB;AAC1B;AACA;;CAEC,uBAAuB;AACxB;AACA;CACC,sBAAsB;CACtB,QAAQ;AACT;AACA;CACC,aAAa;CACb,2BAA2B;CAC3B,OAAO;AACR;AACA;;CAEC,aAAa;AACd;;AAEA;IACI,oBAAoB;AACxB;AACA;IACI,cAAc;AAClB;AACA;;IAEI,yBAAyB;AAC7B;AACA;CACC,gBAAgB;AACjB;AACA;CACC,eAAe;CACf,gBAAgB;AACjB;;AAEA;;;;IAII,sBAAsB;CACzB,kCAAkC;AACnC;AACA;CACC,aAAa;AACd;AACA;CACC,kBAAkB;AACnB;AACA;CACC,YAAY;AACb;AACA;CACC,uBAAuB;AACxB;AACA;CACC,uBAAuB;AACxB;AACA;CACC,aAAa;CACb,mBAAmB;CACnB,YAAY;AACb;AACA;CACC,2BAA2B;CAC3B,6BAA6B;AAC9B;AACA;CACC,sBAAsB;AACvB;AACA;;CAEC,eAAe;AAChB;AACA;CACC;;EAEC,0BAA0B;CAC3B;AACD;AACA;CACC,wBAAwB;CACxB,eAAe;CACf,mBAAmB;CACnB,QAAQ;AACT;AACA;CACC,aAAa;AACd;AACA;CACC,kBAAkB;AACnB;AACA;;CAEC,aAAa;AACd;AACA;CACC,eAAe;CACf,kBAAkB;AACnB;AACA;CACC,eAAe;AAChB;AACA;;CAEC,wBAAwB;AACzB;AACA;CACC,iBAAiB;CACjB,aAAa;CACb,mBAAmB;CACnB,uBAAuB;AACxB;AACA;IACI,uBAAuB;CAC1B,yBAAyB;CACzB,4BAA4B;AAC7B;AACA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,eAAe;AACnB;AACA;CACC,aAAa;CACb,mBAAmB;CACnB,uBAAuB;AACxB;AACA;;;;GAIG;AACH;CACC,kBAAkB;AACnB;AACA;CACC,yBAAyB;CACzB,gBAAgB;AACjB;AACA;CACC,0CAA0C;IACvC,kBAAkB;AACtB;AACA;CACC,oCAAoC;CACpC,iCAAiC;CACjC,uBAAuB;CACvB,gBAAgB;AACjB;AACA;CACC,oCAAoC;AACrC;AACA;CACC,oCAAoC;CACpC,iCAAiC;CACjC,yBAAyB;CACzB,yBAAyB;CACzB,gBAAgB;CAChB,4BAA4B;AAC7B;AACA;CACC,oCAAoC;AACrC;AACA;CACC,wCAAwC;AACzC;AACA;CACC,uCAAuC;AACxC;AACA;CACC,uCAAuC;AACxC;AACA;CACC,oCAAoC;AACrC;AACA;CACC,UAAU;CACV,wBAAwB;AACzB;AACA;IACI,kBAAkB;IAClB,UAAU;IACV,UAAU;IACV,YAAY;IACZ,YAAY;IACZ,mBAAmB;AACvB;AACA;CACC,0BAA0B;AAC3B;AACA;CACC,wBAAwB;AACzB;AACA;CACC,UAAU;AACX;AACA;CACC,uBAAuB;CACvB,YAAY;CACZ,oCAAoC;;AAErC;AACA;;CAEC,uCAAuC;AACxC;AACA;CACC,oCAAoC;AACrC;AACA;CACC,mBAAmB;AACpB;AACA;CACC,oCAAoC;AACrC;AACA;CACC,oCAAoC;CACpC,yBAAyB;CACzB,yBAAyB;CACzB,mBAAmB;AACpB;AACA;CACC,cAAc;AACf;AACA;;CAEC,gCAAgC;CAChC,0CAA0C;AAC3C;AACA;CACC,uBAAuB;CACvB,oCAAoC;CACpC,gCAAgC;AACjC;AACA;CACC,eAAe;AAChB;AACA;CACC,aAAa;CACb,sBAAsB;CACtB,mBAAmB;;AAEpB;AACA;CACC,oBAAoB;CACpB,gBAAgB;IACb,mBAAmB;IACnB,kBAAkB;AACtB;AACA;;CAEC,uBAAuB;CACvB,2BAA2B;CAC3B,wCAAwC;AACzC;AACA;CACC,gCAAgC;AACjC;AACA;;CAEC,cAAc;AACf;AACA;CACC,eAAe;AAChB;AACA;IACI,2BAA2B;AAC/B;AACA;CACC,oCAAoC;CACpC,iCAAiC;CACjC,yBAAyB;CACzB,kCAAkC;AACnC;AACA;CACC,2BAA2B;AAC5B;AACA;;;;;;;;CAQC,sCAAsC;CACtC,2BAA2B;AAC5B;AACA;CACC,mBAAmB;AACpB;AACA;;CAEC,sCAAsC;IACnC,qBAAqB;AACzB;AACA;CACC,sBAAsB;AACvB;AACA;;CAEC,cAAc;CACd,gBAAgB;AACjB;AACA;IACI,gCAAgC;IAChC,uBAAuB;IACvB,UAAU;AACd;AACA;CACC,uBAAuB;IACpB,2BAA2B;AAC/B;AACA;CACC,oCAAoC;CACpC,6CAA6C;AAC9C;AACA;;;;;;;;;;;;;CAaC,uBAAuB;CACvB,2BAA2B;AAC5B;;AAEA;;;;CAIC,uBAAuB;AACxB;AACA;CACC,aAAa;AACd;AACA;;CAEC,cAAc;AACf;AACA;;CAEC,cAAc;AACf;AACA;;CAEC,oCAAoC;AACrC;AACA;;CAEC,oCAAoC;AACrC;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,oCAAoC;AACrC;AACA;CACC,oCAAoC;CACpC,iCAAiC;CACjC,yBAAyB;CACzB,2BAA2B;CAC3B,4BAA4B;CAC5B,0BAA0B;CAC1B,uBAAuB;AACxB;AACA;CACC,cAAc;AACf;AACA;CACC,mCAAmC;AACpC;AACA;CACC,yBAAyB;IACtB,qBAAqB;AACzB;AACA;;;CAGC,gCAAgC;AACjC;AACA;CACC,aAAa;CACb,mBAAmB;AACpB;AACA;CACC,WAAW;IACR,YAAY;IACZ,eAAe;CAClB,wCAAwC;AACzC;AACA;CACC,aAAa;CACb,mBAAmB;CACnB,eAAe;AAChB;AACA;CACC,cAAc;AACf;AACA;CACC,mBAAmB;AACpB;AACA;CACC,8BAA8B;IAC3B,iCAAiC;AACrC;AACA;CACC,6BAA6B;AAC9B;AACA;CACC,uBAAuB;AACxB;AACA;;;;;;;IAOI,gCAAgC;IAChC,2BAA2B;IAC3B,uBAAuB;IACvB,UAAU;AACd;AACA;CACC,uBAAuB;AACxB;AACA;;;;;CAKC,yBAAyB;AAC1B;AACA;CACC,aAAa;IACV,QAAQ;IACR,sBAAsB;AAC1B;AACA;CACC,QAAQ;AACT;AACA;CACC,YAAY;CACZ,aAAa;CACb,kBAAkB;AACnB;AACA;CACC,oCAAoC;CACpC,gCAAgC;AACjC;AACA;CACC,sCAAsC;AACvC;AACA;CACC,sCAAsC;CACtC,2BAA2B;AAC5B;AACA;CACC,uBAAuB;CACvB,gCAAgC;AACjC;AACA;;CAEC,uBAAuB;CACvB,2BAA2B;AAC5B;AACA;CACC,WAAW;CACX,YAAY;AACb;AACA;CACC,iBAAiB;AAClB;AACA;CACC,2BAA2B;AAC5B;AACA;CACC,mBAAmB;;AAEpB;AACA;CACC,gBAAgB;AACjB;AACA;CACC;AACD;AACA;CACC;EACC,8BAA8B;EAC9B,iCAAiC;CAClC;CACA;EACC,4BAA4B;CAC7B;CACA;EACC,4BAA4B;CAC7B;AACD;AACA;CACC;EACC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;CACxB;CACA;EACC,aAAa;EACb,mBAAmB;CACpB;CACA;;EAEC,gCAAgC;CACjC;CACA;EACC,eAAe;CAChB;CACA;EACC,cAAc;CACf;CACA;EACC,eAAe;CAChB;CACA;EACC,gBAAgB;CACjB;CACA;EACC,WAAW;EACX,YAAY;CACb;CACA;EACC,iBAAiB;CAClB;AACD;AACA;CACC;;EAEC,aAAa;CACd;CACA;EACC,gBAAgB;EAChB,eAAe;EACf,gBAAgB;CACjB;CACA;EACC,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;CAChB;CACA;EACC,6BAA6B;CAC9B;CACA;;EAEC,eAAe;CAChB;AACD;AAz0BA;EAAA;AAy0BC;AAz0BD;EAAA;AAy0BC;AAz0BD;EAAA;AAy0BC;AAz0BD;EAAA;AAy0BC;AAz0BD;EAAA;AAy0BC;AAz0BD;EAAA;AAy0BC;AAz0BD;EAAA,6BAy0BC;EAz0BD;AAy0BC;AAz0BD;EAAA,6BAy0BC;EAz0BD;AAy0BC;AAz0BD;EAAA,8BAy0BC;EAz0BD;AAy0BC;AAz0BD;EAAA,8BAy0BC;EAz0BD;AAy0BC;AAz0BD;EAAA;AAy0BC;AAz0BD;EAAA,+BAy0BC;EAz0BD;AAy0BC;AAz0BD;EAAA;AAy0BC;AAz0BD;EAAA,iCAy0BC;EAz0BD;AAy0BC;AAz0BD;EAAA,iCAy0BC;EAz0BD;AAy0BC;AAz0BD;EAAA,6BAy0BC;EAz0BD;AAy0BC;AAz0BD;EAAA,6BAy0BC;EAz0BD;AAy0BC;AAz0BD;EAAA,6BAy0BC;EAz0BD;AAy0BC;AAz0BD;EAAA,6BAy0BC;EAz0BD;AAy0BC;AAz0BD;EAAA,6BAy0BC;EAz0BD;AAy0BC;AAz0BD;EAAA,6BAy0BC;EAz0BD;AAy0BC;AAz0BD;EAAA,6BAy0BC;EAz0BD;AAy0BC;AAz0BD;EAAA,6BAy0BC;EAz0BD;AAy0BC;AAz0BD;EAAA,6BAy0BC;EAz0BD;AAy0BC;AAz0BD;EAAA,6BAy0BC;EAz0BD;AAy0BC;AAz0BD;EAAA,6BAy0BC;EAz0BD;AAy0BC;AAz0BD;EAAA,6BAy0BC;EAz0BD;AAy0BC;AAz0BD;EAAA,6BAy0BC;EAz0BD;AAy0BC;AAz0BD;EAAA,6BAy0BC;EAz0BD;AAy0BC;AAz0BD;EAAA,6BAy0BC;EAz0BD;AAy0BC;AAz0BD;EAAA,6BAy0BC;EAz0BD;AAy0BC;AAz0BD;EAAA,6BAy0BC;EAz0BD;AAy0BC;AAz0BD;EAAA,6BAy0BC;EAz0BD;AAy0BC;AAz0BD;EAAA,6BAy0BC;EAz0BD;AAy0BC;AAz0BD;EAAA,6BAy0BC;EAz0BD;AAy0BC;AAz0BD;EAAA,+BAy0BC;EAz0BD;AAy0BC;AAz0BD;EAAA,+BAy0BC;EAz0BD;AAy0BC;AAz0BD;EAAA,+BAy0BC;EAz0BD;AAy0BC;AAz0BD;EAAA,+BAy0BC;EAz0BD;AAy0BC;AAz0BD;EAAA,+BAy0BC;EAz0BD;AAy0BC;AAz0BD;EAAA,+BAy0BC;EAz0BD;AAy0BC;AAz0BD;EAAA;AAy0BC;AAz0BD;EAAA,6BAy0BC;EAz0BD;AAy0BC;AAz0BD;EAAA,iCAy0BC;EAz0BD;AAy0BC;AAz0BD;EAAA,iCAy0BC;EAz0BD;AAy0BC;AAz0BD;EAAA,+BAy0BC;EAz0BD;AAy0BC;AAz0BD;EAAA,iCAy0BC;EAz0BD,yCAy0BC;EAz0BD;AAy0BC;AAz0BD;EAAA,yCAy0BC;EAz0BD;AAy0BC;AAz0BD;EAAA,sHAy0BC;EAz0BD,oHAy0BC;EAz0BD;AAy0BC;AAz0BD;EAAA,yCAy0BC;EAz0BD;AAy0BC;AAz0BD;EAAA,6BAy0BC;EAz0BD;AAy0BC;AAz0BD;EAAA;AAy0BC;AAz0BD;EAAA;AAy0BC;AAz0BD;EAAA,gCAy0BC;EAz0BD;AAy0BC;AAz0BD;EAAA,iCAy0BC;EAz0BD;AAy0BC;AAz0BD;EAAA,6BAy0BC;EAz0BD;AAy0BC;AAz0BD;EAAA,6BAy0BC;EAz0BD;AAy0BC;AAz0BD;EAAA,6BAy0BC;EAz0BD;AAy0BC;AAz0BD;EAAA,+BAy0BC;EAz0BD;AAy0BC;AAz0BD;EAAA,+BAy0BC;EAz0BD;AAy0BC;AAz0BD;EAAA,+BAy0BC;EAz0BD;AAy0BC;AAz0BD;;EAAA;IAAA;EAy0BC;;EAz0BD;IAAA;EAy0BC;;EAz0BD;IAAA;EAy0BC;;EAz0BD;IAAA;EAy0BC;;EAz0BD;IAAA;EAy0BC;;EAz0BD;IAAA;EAy0BC;;EAz0BD;IAAA,6BAy0BC;IAz0BD;EAy0BC;AAAA;AAz0BD;;EAAA;IAAA;EAy0BC;;EAz0BD;IAAA;EAy0BC;;EAz0BD;IAAA;EAy0BC;;EAz0BD;IAAA;EAy0BC;;EAz0BD;IAAA;EAy0BC;;EAz0BD;IAAA;EAy0BC;;EAz0BD;IAAA;EAy0BC;;EAz0BD;IAAA;EAy0BC;;EAz0BD;IAAA;EAy0BC;;EAz0BD;IAAA;EAy0BC;;EAz0BD;IAAA;EAy0BC;;EAz0BD;IAAA;EAy0BC;;EAz0BD;IAAA;EAy0BC;;EAz0BD;IAAA;EAy0BC;;EAz0BD;IAAA;EAy0BC;;EAz0BD;IAAA;EAy0BC;;EAz0BD;IAAA;EAy0BC;;EAz0BD;IAAA;EAy0BC;;EAz0BD;IAAA;EAy0BC;;EAz0BD;IAAA,+BAy0BC;IAz0BD;EAy0BC;;EAz0BD;IAAA,6BAy0BC;IAz0BD;EAy0BC;;EAz0BD;IAAA;EAy0BC;;EAz0BD;IAAA;EAy0BC;;EAz0BD;IAAA,4BAy0BC;IAz0BD;EAy0BC;;EAz0BD;IAAA;EAy0BC;AAAA;AAz0BD;;EAAA;IAAA;EAy0BC;;EAz0BD;IAAA;EAy0BC;;EAz0BD;IAAA;EAy0BC;;EAz0BD;IAAA;EAy0BC;;EAz0BD;IAAA;EAy0BC;;EAz0BD;IAAA;EAy0BC;;EAz0BD;IAAA;EAy0BC;;EAz0BD;IAAA;EAy0BC;;EAz0BD;IAAA,+BAy0BC;IAz0BD;EAy0BC;;EAz0BD;IAAA,4BAy0BC;IAz0BD;EAy0BC;AAAA;AAz0BD;;EAAA;IAAA;EAy0BC;;EAz0BD;IAAA;EAy0BC;;EAz0BD;IAAA,+BAy0BC;IAz0BD;EAy0BC;AAAA","sourcesContent":["@import \"~antd/dist/antd.css\";\n\n@tailwind base;\n@tailwind components;\n@tailwind utilities;\n@import url(\"https://fonts.googleapis.com/css2?family=Poppins&display=swap\");\n\n@layer base {\n\thtml,\n\tbody {\n\t\t-webkit-tap-highlight-color: transparent;\n\t}\n\n\t/* Chrome, Safari, Edge, Opera */\n\tinput::-webkit-outer-spin-button,\n\tinput::-webkit-inner-spin-button {\n\t\t-webkit-appearance: none;\n\t\tmargin: 0;\n\t\twidth: 99vw;\n\t}\n\n\t/* Firefox */\n\tinput[type=\"number\"] {\n\t\t-moz-appearance: textfield;\n\t}\n\n\tbody {\n\t\t@apply dark:text-white;\n\t}\n}\n\n@layer components {\n\t.tw-container {\n\t\t@apply w-11/12 lg: max-w-[80rem] mx-auto;\n\t}\n\n\t.stageStartBtn {\n\t\tclip-path: polygon(90% 0, 100% 50%, 90% 100%, 0% 100%, 0% 50%, 0% 0%);\n\t}\n\n\t.stageBtn {\n\t\tclip-path: polygon(90% 0, 100% 50%, 90% 100%, 0% 100%, 10% 50%, 0% 0%);\n\t}\n\n\t.stageEndBtn {\n\t\tclip-path: polygon(100% 0, 100% 50%, 100% 100%, 0% 100%, 10% 50%, 0% 0%);\n\t}\n}\n\nhtml,\nbody {\n\tmargin: 0;\n\tfont-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\",\n\t\t\"Ubuntu\", \"Cantarell\", \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\",\n\t\tsans-serif;\n\t-webkit-font-smoothing: antialiased;\n\t-moz-osx-font-smoothing: grayscale;\n}\n\ncode {\n\tfont-family: source-code-pro, Menlo, Monaco, Consolas, \"Courier New\",\n\t\tmonospace;\n}\n\n.ant-btn-primary {\n\tbackground: #E5383B !important;\n\tborder-color: #E5383B !important;\n}\n\n.ant-btn-primary:focus,\n.ant-btn-primary:hover {\n\tbackground: #40a9ff !important;\n}\n\n.ant-table .ant-table-container .ant-table-content table thead.ant-table-thead {\n\tbackground-color: #f3f4f6 !important;\n\tcolor: black !important;\n}\n\n.ant-table-thead > tr > th {\n\tcolor: black !important;\n\tfont-weight: 700;\n\tbackground-color: transparent;\n\tfont-size: 13px;\n}\n\n.ant-layout-sider {\n\tcolor: #ffffff;\n}\n\n.ant-menu-item a {\n\tcolor:  #161A1D!important;\n\tpadding: 0 10px;\n\tfont-size: 16px !important;\n\tfont-weight: 500 !important;\n}\n\n/* .ant-menu-item .active {\n  background-color: #3a3a3a !important;\n} */\n\n.ant-picker-panels > *:first-child button.ant-picker-header-next-btn {\n\tvisibility: visible !important;\n}\n\n.ant-picker-panels > *:first-child button.ant-picker-header-super-next-btn {\n\tvisibility: visible !important;\n}\n\n.ant-picker-panels > *:last-child {\n\tdisplay: none;\n}\n\n.ant-picker-panel-container,\n.ant-picker-footer {\n\twidth: 280px !important;\n}\n\n.ant-picker-footer-extra > div {\n\tflex-wrap: wrap !important;\n}\n\n.ant-card-head {\n\tmin-height: 40px;\n}\n.table-card .ant-table-wrapper{\n\tborder: 1px solid white;\n\tmargin-top: 1rem !important;\n}\n.custom-filter-btn{\n\tbackground-color: #e40a0a !important;\n\tcolor:white;\n\tborder: none;\n}\n.custom-filter-btn:hover,\n.custom-filter-btn:focus{\n\tbackground-color: #F00000 !important;\n\tcolor:white !important;\n}\n /* .franchise-card{\n\tbox-shadow: 0 3px 10px rgb(0 0 0 / 0.2);\n } */\n.franchise-form .ant-form-item-label{\n\tdisplay: flex;\n\tjustify-content: start;\n\tfont-weight: 700 !important;\n}\n.franchise-form .ant-form-item-control input,\n.franchise-form .ant-form-item-control textarea,\n.franchise-form .ant-form-item-control select,\n.franchise-form .ant-form-item-control .ant-select-selector,\n.franchise-form .ant-input-status-error:not(.ant-input-disabled):not( .ant-input-borderless ).ant-input,\n.franchise-form #fileInput{\n    display: flex;\n    padding-top: 10px !important;\n    padding-bottom: 10px !important;\n    align-items: center;\n    gap: 4px;\n    border-radius: 4px !important;\n    /* border: none; */\n    border: 0.5px solid #ccc !important;\n\ttransition: border-color 0.2s ease;\n    /* box-shadow: 0 3px 10px rgb(0 0 0 / 0.1); */\n\tcolor: #363131 !important;\n\twidth: 100%;\n}\n.login-form .username-field,\n.login-form #basic_password,\n.login-form .ant-input-status-error:not(.ant-input-disabled):not( .ant-input-borderless ).ant-input{\n\tdisplay: flex;\n    padding-top: 10px !important;\n    padding-bottom: 10px !important;\n    align-items: center;\n    gap: 4px;\n    border-radius: 8px !important;\n    border: 1px solid #202126 !important;\n    background: #202126 !important;\n    box-shadow: 0px 1px 2px 0px rgba(15, 23, 42, 0.06);\n\tcolor: white !important;\n}\n/* .card-wrapper table,.card-wrapper th,.card-wrapper td,\n.role-wrapper table,.role-wrapper th,.role-wrapper td,\n.table-card table,.table-card th,.table-card td,\n.game-card table,.game-card th,.game-card td,\n.ant-table-tbody > tr.ant-table-row-selected > td{\n\tborder: 1px solid #0E0D12;\n\tborder-collapse: collapse;\n} */\n.table-card .ant-checkbox {\n\twidth: 18px;\n\theight: 18px;\n\tborder: 1px solid #0E0D12;\n\tborder-radius: 4px;\n}\n.login-wrapper .ant-card-body{\n \tborder-radius: 1.25rem;\n\tbackground-color: white !important;\n}\n .sidebar-menu .ant-menu-submenu > .ant-menu,\n .sidebar-menu .ant-menu-submenu > .ant-menu a,\n .sidebar-menu .ant-menu:not(.ant-menu-horizontal) .ant-menu-item-selected,\n .ant-menu-item:active\n {\n\tbackground-color: white !important;\n\tcolor: #161A1D !important;\n }\n .sidebar-menu .ant-menu-submenu > .ant-menu > li:hover,\n .sidebar-menu .ant-menu-submenu > .ant-menu > li:hover a,\n .ant-menu-sub > .ant-menu-item a.active{\n\tbackground-color: #202126 !important;\n }\n .sidebar-menu .ant-menu-light .ant-menu-submenu-title:hover,\n .sidebar-menu .ant-menu-submenu-selected {\n\tcolor: white !important;\n }\n .sidebar-menu .ant-menu-submenu-title:active{\n\tbackground-color: #0e0d12 !important;\n }\n .page-height{\n\tmin-height: 90vh !important;\n}\n.side-bar{\n\tposition: fixed;\n\tleft: 0;\n\ttop: 64px;\n\t/* max-width: none !important; */\n}\n.ant-table-tbody > tr > td {\n\tborder-bottom: 1px solid #0E0D12;\n}\n.role-wrapper .ant-select-multiple .ant-select-selection-item{\n\tborder: none;\n}\n.stepper-wrapper {\n\tbackground-color: white;\n\tpadding: 24px 24px 0 24px;\n}\n.login-page{\n\tmargin-left: -200px !important;\n\tmargin-top: -1rem !important;\n}\n.username-field .ant-input-suffix{\n\tmargin-right: 10px !important;\n}\n.franchise-form #fileInput{\n\tpadding-left: 10px !important;\n}\n.franchise-form .ant-select-show-search.ant-select:not(.ant-select-customize-input) .ant-select-selector{\n\theight: 44px !important;\n}\n/* .franchise-second-step, .franchise-third-step, .franchise-last-step, .franchise-card{\n\tbox-shadow: 0 3px 10px rgb(0 0 0 / 0.2);\n} */\n.ant-drawer-content-wrapper .ant-form-vertical input,.franchise-search-input,.upload-input .ant-btn{\n\tborder: 0.8px solid #bbbbbb;\n}\n.ant-drawer-content-wrapper .ant-form-vertical .ant-form-item-label > label{\n\tfont-weight: 600;\n}\n.card-wrapper .ant-select-selection-item,\n.game-card .ant-select-selection-item,\n.table-card .ant-select-selection-item{\n\tborder: none;\n}\ninput#quoteDate{\n\tborder: none;\n}\n.ant-steps-item-process > .ant-steps-item-container > .ant-steps-item-icon {\n    background: #FFCDCB;\n\tborder: 1px solid #E5383B;\n\tcolor: #E5383B !important;\n}\n.ant-steps-item-process > .ant-steps-item-container > .ant-steps-item-icon > span {\n\tcolor: #E5383B !important;\n}\n#end_date,#start_date,#bookingDate,\n#end_date:hover,#start_date:hover,#bookingDate:hover{\n\tborder: none !important;\n}\n.form-item-alignment .ant-row {\n\tflex-direction: column;\n\tgap: 2px;\n}\n.form-item-alignment .ant-form-item-required {\n\tdisplay: flex;\n\tflex-direction: row-reverse;\n\tgap:2px;\n}\n.form-item-alignment .ant-form-item-required::after,\n.form-item-alignment .ant-form-item-label > label::after {\n\tdisplay: none;\n}\n\n.stepper-wrapper .ant-steps-item-finish .ant-steps-item-icon {\n    border-color:#e40a0a;\n}\n.stepper-wrapper .anticon {\n    color: #e40a0a;\n}\n.stepper-wrapper .ant-steps-item-finish > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-title::after,\n.stepper-wrapper .ant-steps-item-finish > .ant-steps-item-container > .ant-steps-item-tail::after {\n    background-color: #e40a0a;\n}\n.franchise-second-step label{\n\tfont-weight: 600;\n}\n.ant-drawer-title,.ant-drawer-close svg{\n\tfont-size: 18px;\n\tfont-weight: 600;\n}\n\n.slot-grid .ant-table-thead > tr > th,\n.franchise-last-step .ant-table-thead > tr > th,\n.slot-grid .ant-table-tbody > tr > td,\n.franchise-last-step .ant-table-tbody > tr > td {\n    border:none !important;\n\tvertical-align: initial !important;\n}\n.side-bar .ant-layout-sider-trigger{\n\tdisplay: none;\n}\n.ant-drawer-content-wrapper .ant-drawer-body {\n\toverflow-x: hidden;\n}\n.franchise-days-section .franchise-time{\n\theight: 44px;\n}\n.franchise-days-section .franchise-time input{\n\tborder: none !important;\n}\n.franchise-form .buffer-time input{\n\tborder: none !important;\n}\n.franchise-form .buffer-time .ant-form-item-control-input-content .ant-input-number{\n\tdisplay: flex;\n\talign-items: center;\n\theight: 44px;\n}\n.time-wrapper {\n\tborder: 0.8px solid #bbbbbb;\n\tborder-radius: 4px !important;\n}\n.franchise-form .ant-form-item-label{\n\twidth: 100% !important;\n}\n.table-card .ant-select-selection-item-content,\n.card-wrapper .ant-select-selection-item-content{\n\tfont-size: 12px;\n}\n@media screen and (min-width:768px){\n\t.table-card .ant-select-selection-item-content,\n\t.card-wrapper .ant-select-selection-item-content{\n\t\tfont-size: 14px !important;\n\t}\n}\n.stepper-wrapper{\n\tdisplay: flex !important;\n\tflex-wrap: wrap;\n\tflex-direction: row;\n\tgap: 8px;\n}\n.stepper-wrapper .ant-steps-item{\n\tdisplay: flex;\n}\n.stepper-wrapper .ant-steps-item.ant-steps-item-active{\n\twidth: max-content;\n}\n.stepper-wrapper .ant-steps-item.ant-steps-item-active .ant-steps-item-description,\n.stepper-wrapper .ant-steps-item .ant-steps-item-description{\n\tdisplay: none;\n}\n.stepper-wrapper .ant-steps-item.ant-steps-item-active .ant-steps-item-title{\n\tfont-size: 14px;\n\tpadding-right: 4px;\n}\n.ant-steps-vertical > .ant-steps-item .ant-steps-item-icon{\n\tmargin-top: 4px;\n}\n.ant-steps-item-wait .ant-steps-item-content,\n.ant-steps-item-finish .ant-steps-item-content{\n\tdisplay: none !important;\n}\n.ant-steps-vertical > .ant-steps-item .ant-steps-item-icon {\n\tmargin-right: 8px;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n}\n.franchise-form .franchise-days-section .ant-select-show-search.ant-select:not(.ant-select-customize-input) .ant-select-selector {\n    height: 76px !important;\n\tpadding-top: 0 !important;\n\tpadding-bottom: 0 !important;\n}\n.stepper-wrapper .ant-steps-item-icon {\n    width: 24px;\n    height: 24px;\n    margin: 0 8px 0 0;\n    font-size: 12px;\n}\n.ant-steps-item-finish .ant-steps-icon{\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n}\n/* .franchise-last-step table,.franchise-last-step th,.franchise-last-step tr,.franchise-last-step td,\n.franchise-third-step table,.franchise-third-step th,.franchise-third-step tr,.franchise-third-step td{\n\tborder: 1px solid;\n\tborder-collapse: collapse;\n} */\n.franchise-third-step .ant-table-content{\n\toverflow-x: scroll;\n}\n.sidebar-menu .ant-menu:not(.ant-menu-horizontal) .ant-menu-item-selected span a span{\n\tcolor: #E5383B !important;\n\tfont-weight: 600;\n}\n.ant-menu-inline .ant-menu-item::after {\n\tborder-right: 5px solid #E5383B !important;\n    border-radius: 3px;\n}\n.btn-primary{\n background-color: #E5383B !important;\n border-radius: 1.25rem !important;\n color: white !important;\n font-weight: 500;\n}\n.btn-primary:hover{\n\tbackground-color: #e61013 !important;\n}\n.btn-secondary{\n\tbackground-color: #FFCDCB !important;\n\tborder-radius: 1.25rem !important;\n\tcolor: #E5383B !important;\n\tborder: 1px solid #E5383B;\n\tfont-weight: 600;\n\tpadding: 4px 16px !important;\n}\n.btn-secondary:hover{\n\tborder: 1px solid #E5383B !important;\n}\n.card-custom{\n\tbackground-color: transparent !important;\n}\n.border-radius-top{\n\tborder-radius: 16px 16px 0 0 !important;\n}\n.border-radius-bottom{\n\tborder-radius: 0 0 16px 16px !important;\n}\n.min-h-screen.ant-layout {\n\tbackground-color: #F3EDE8 !important;\n}\n.ant-steps-vertical > .ant-steps-item > .ant-steps-item-container > .ant-steps-item-tail::after{\n\twidth:20px;\n\theight: 1.5px !important;\n}\n.ant-steps-vertical > .ant-steps-item > .ant-steps-item-container > .ant-steps-item-tail {\n    position: absolute;\n    top: -22px;\n    left: 30px;\n    width: 100px;\n    height: 100%;\n    padding: 38px 0 6px;\n}\n.table-top-padding{\n\tpadding:24px 24px 0px 24px;\n}\n.table-inner-padding{\n\tpadding:0 24px 24px 24px;\n}\n.ant-input-search > .ant-input-group > .ant-input-group-addon:last-child {\n\tleft: -3px;\n}\n.ant-table-thead > tr > th {\n\tcolor: white !important;\n\tborder: none;\n\tbackground-color: #27272A !important;\n\n}\n.ant-table-thead > tr > th:first-child,\n.ant-table-tbody > tr >td:first-child{\n\tborder-radius: 12px 0 0 12px !important;\n}\n.odd-row{\n\tbackground-color: #F2F2F2 !important;\n}\n.ant-table-tbody > tr > td {\n\tborder-bottom: none;\n}\n.ant-table-thead > tr > th:not(:last-child):not(.ant-table-selection-column):not(.ant-table-row-expand-icon-cell):not([colspan])::before {\n\tbackground-color: #464648 !important;\n}\n.ant-pagination-item-active{\n\tbackground-color: #FFCDCB !important;\n\tcolor: #E5383B !important;\n\tborder: 1px solid #E5383B;\n\tborder-radius: 12px;\n}\n.ant-pagination-item-active a{\n\tcolor: #E5383B;\n}\n.ant-input-search .ant-input:hover,\n.ant-input-search .ant-input:focus{\n\tborder-color: #d9d9d9 !important;\n\tbox-shadow: 0 0 0 2px rgb(255 24 33 / 20%);\n}\n.ant-select-show-search.ant-select:not(.ant-select-customize-input).column-selector .ant-select-selector{\n\theight: 30px !important;\n\tborder: 1px solid #bbbbbb !important;\n\tborder-radius: 0.5rem !important;\n}\n.column-selector .ant-select-selector .ant-select-selection-item-content{\n\tfont-size: 11px;\n}\n.ant-spin-container{\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: normal;\n\n}\n.ant-pagination{\n\talign-self: flex-end;\n\tpadding: 4px 8px;\n    background: #F2F2F2;\n    border-radius: 8px;\n}\n.ant-pagination .ant-pagination-prev button,\n.ant-pagination .ant-pagination-next button{\n\tborder: none !important;\n\tbackground: none !important;\n\tbackground-color: transparent !important;\n}\n.ant-pagination-item:hover ,.ant-pagination-item-active:hover {\n\tborder-color: #DD0707 !important;\n}\n.ant-pagination-item:hover a,\n.ant-pagination-item-active:hover a{\n\tcolor: #DD0707;\n}\n.stepper-wrapper .ant-steps-item-container {\n\tcursor: pointer;\n}\n.ant-drawer-header-title {\n    flex-direction: row-reverse;\n}\n.btn-tertiary{\n\tborder: 1px solid #E5383B !important;\n\tborder-radius: 1.25rem !important;\n\tcolor: #E5383B !important;\n\tbackground-color: white !important;\n}\n.ant-select:not(.ant-select-customize-input) .ant-select-selector,.ant-picker {\n\tborder: 0.8px solid #bbbbbb;\n}\n.ant-picker:hover,\n.franchise-form .ant-form-item-control input:hover,\n.ant-picker-focused,\n.ant-input:focus,\n.ant-input:hover,\n.ant-form-item-control textarea:hover,\n.ant-form-item-control input:hover,\n.time-wrapper:hover {\n\tborder: 0.8px solid #010000 !important;\n\tbox-shadow: none !important;\n}\n.ant-pagination-item{\n\tborder-radius: 12px;\n}\n.ant-select:not(.ant-select-disabled):hover .ant-select-selector,\n.ant-input-number:hover {\n\tborder: 0.8px solid #010000 !important;\n    border-right-width: 0;\n}\n.username .ant-form-item-label,.password .ant-form-item-label{\n\talign-self: flex-start;\n}\n.username .ant-form-item-label label,\n.password .ant-form-item-label label{\n\tcolor: #111827;\n\tfont-weight: 500;\n}\n.password .ant-input-affix-wrapper:not(.ant-input-affix-wrapper-disabled):hover {\n    border-color: #010000 !important;\n    border-right-width: 1px;\n    z-index: 1;\n}\n.pass-field .ant-input:hover {\n\tborder: none !important;\n    box-shadow: none !important;\n}\n.pass-field .ant-input{\n\tbackground-color: #f9fafb !important;\n\tborder-radius: 0.75rem 0 0 0.75rem !important;\n}\n.time-wrapper .start-time,\n.time-wrapper #start-time input,\n.time-wrapper #end-time input,\n.time-wrapper .end-time,\n.ant-picker.ant-picker-small#start-time:hover,\n.ant-picker.ant-picker-small#end-time:hover,\n.start-time .ant-picker-focused,\n.end-time .ant-picker-focused,\n.franchise-third-step .ant-input-number-input,\n.franchise-third-step .ant-input-number-input:hover,\n.franchise-last-step .ant-input-number-input:hover,\n.franchise-last-step .ant-input-number-input\n{\n\tborder: none !important;\n\tbox-shadow: none !important;\n}\n\n.time-wrapper .start-time #start-time,\n.time-wrapper .end-time #end-time,\n.date-picker .ant-picker-input input,\n.date-picker .ant-picker-input input:hover{\n\tborder: none !important;\n}\n.ant-picker-active-bar{\n\tdisplay: none;\n}\n.ant-pagination-prev.ant-pagination-disabled button span svg,\n.ant-pagination-next.ant-pagination-disabled button span svg{\n\tcolor: #ada7a7;\n}\n.password .ant-col-24.ant-form-item-label,\n.username .ant-col-24.ant-form-item-label{\n\tpadding: 0 0 0;\n}\n.ant-select-item-option-selected,\n.ant-picker-time-panel-column > li.ant-picker-time-panel-cell-selected .ant-picker-time-panel-cell-inner  {\n\tbackground-color: #f8e1e1 !important;\n}\n.ant-select-item-option-active:not(.ant-select-item-option-disabled)\n{\n\tbackground-color: #FFCDCB !important;\n}\n.ant-select-item-option-selected:not(.ant-select-item-option-disabled) .ant-select-item-option-state {\n\tcolor: #E5383B !important;\n}\n.ant-picker-cell-in-view.ant-picker-cell-selected .ant-picker-cell-inner{\n\tbackground-color: #E5383B !important;\n}\n.ant-select-multiple.ant-select-sm .ant-select-selection-item {\n\tbackground-color: #FFCDCB !important;\n\tborder-radius: 1.25rem !important;\n\tcolor: #E5383B !important;\n\tborder: 0.8px solid #E5383B;\n\tpadding: 0px 10px !important;\n\tfont-size: 12px !important;\n\theight: 20px !important;\n}\n.franchise-days-section .anticon.anticon-close{\n\tcolor: #E5383B;\n}\n.ant-checkbox-checked::after {\n\tborder:1px solid #E5383B !important;\n}\n.ant-checkbox-checked .ant-checkbox-inner {\n\tbackground-color: #E5383B;\n    border-color: #E5383B;\n}\n.ant-checkbox-wrapper:hover .ant-checkbox-inner,\n.ant-checkbox:hover .ant-checkbox-inner,\n.ant-checkbox-input:focus + .ant-checkbox-inner {\n\tborder-color: #E5383B !important;\n}\n.ant-pagination-options{\n\tdisplay: flex;\n\talign-items: center;\n}\n.ant-pagination-options .ant-select-single:not(.ant-select-customize-input) .ant-select-selector {\n\twidth: 100%;\n    height: 26px;\n    padding: 0 10px;\n\tbackground-color: transparent !important;\n}\n.ant-select-selection-item{\n\tdisplay: flex;\n\talign-items: center;\n\tfont-size: 12px;\n}\n.ant-pagination-options .ant-select-arrow{\n\tfont-size: 9px;\n}\n.ant-pagination-options .ant-select-single.ant-select-show-arrow .ant-select-selection-item{\n\tpadding-right: 16px;\n}\n.ant-table-tbody > tr > .ant-table-cell{\n\tpadding-top: 0.4rem !important;\n    padding-bottom: 0.4rem !important;\n}\n.ant-table-thead>tr>th {\n\tpadding: 12px 12px !important;\n}\ninput#basic_password:focus{\n\tborder: none !important;\n}\n.pass-field.ant-input-affix-wrapper:focus,\n.pass-field.ant-input-affix-wrapper-focused,\n.upload-input .ant-btn:hover,\n.upload-input .ant-btn:focus,\n.upload-input .ant-btn:active,\n.ant-input-number:focus,\n.ant-input-number-focused {\n    border-color: #010000 !important;\n    box-shadow: none !important;\n    border-right-width: 1px;\n    outline: 0;\n}\n.franchise-sts .ant-select-selector{\n\theight: 44px !important;\n}\n.ant-input::placeholder,\ninput::placeholder,\nselect::placeholder,\n.ant-select-selector::placeholder,\n.ant-select-selection-placeholder{\n\tcolor: #a59f9f !important;\n}\n.ant-drawer-content-wrapper label{\n\tdisplay: flex;\n    gap: 2px;\n    justify-content: start;\n}\n.ant-form-item-label > label.ant-form-item-required:not(.ant-form-item-required-mark-optional)::before {\n\torder: 3;\n}\n.difficulty-level .ant-select-selector{\n\theight: 35px;\n\tdisplay: flex;\n\talign-items: start;\n}\n.common-search-input{\n\tborder: 1px solid #bbbbbb !important;\n\tborder-radius: 0.5rem !important;\n}\n.common-search-input:hover {\n\tborder: 0.8px solid #010000 !important;\n}\n.common-search-input:focus,.common-search-input.ant-input-affix-wrapper-focused{\n\tborder: 0.8px solid #010000 !important;\n\tbox-shadow: none !important;\n}\n.common-search-input input{\n\tborder: none !important;\n\tborder-radius: 0.5rem !important;\n}\n.common-search-input input:focus,\n.common-search-input input:hover{\n\tborder: none !important;\n\tbox-shadow: none !important;\n}\n.plus-icon{\n\twidth: 14px;\n\theight: 14px;\n}\n.plus-icon path{\n\tstroke-width: 1px;\n}\n.ant-table-cell-scrollbar:not([rowspan]){\n\tbox-shadow: none !important;\n}\n.ant-modal-content,.ant-modal-header {\n\tborder-radius: 16px;\n\n}\n.ant-modal-title{\n\tfont-weight: 600;\n}\n.ant-modal-footer{\n\tpadding-bottom: 20px\n}\n@media screen and (max-width:414px){\n\t.ant-table-tbody > tr > .ant-table-cell {\n\t\tpadding-top: 0.2rem !important;\n\t\tpadding-bottom: 0.2rem !important;\n\t}\n\t.ant-table-thead>tr>th {\n\t\tpadding: 8px 12px !important;\n\t}\n\t.common-search-input input{\n\t\tpadding: 3px 10px !important;\n\t}\n}\n@media screen and (min-width:768px){\n\t.stepper-wrapper .ant-steps-item .ant-steps-item-icon{\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t}\n\t.stepper-wrapper .ant-steps-item-container{\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t}\n\t.ant-steps-item-wait .ant-steps-item-content,\n\t.ant-steps-item-finish .ant-steps-item-content{\n\t\tdisplay: inline-block !important;\n\t}\n\t.stepper-wrapper .ant-steps-item .ant-steps-item-title {\n\t\tfont-size: 14px;\n\t}\n\t.ant-steps-vertical > .ant-steps-item:not(:last-child) > .ant-steps-item-container > .ant-steps-item-tail{\n\t\tdisplay: block;\n\t}\n\t.column-selector .ant-select-selector .ant-select-selection-item-content{\n\t\tfont-size: 14px;\n\t}\n\t.stepper-wrapper .ant-steps-item .ant-steps-item-title{\n\t\tfont-weight: 600;\n\t}\n\t.plus-icon{\n\t\twidth: 16px;\n\t\theight: 16px;\n\t}\n\t.plus-icon path{\n\t\tstroke-width: 2px;\n\t}\n}\n@media screen and (min-width:1220px){\n\t.stepper-wrapper .ant-steps-item.ant-steps-item-active .ant-steps-item-description,\n\t.stepper-wrapper .ant-steps-item .ant-steps-item-description{\n\t\tdisplay: flex;\n\t}\n\t.stepper-wrapper .ant-steps-item .ant-steps-item-description{\n\t\tfont-weight: 400;\n\t\tfont-size: 12px;\n\t\tline-height: 1.3;\n\t}\n\t.stepper-wrapper .ant-steps-item-icon {\n\t\twidth: 32px;\n\t\theight: 32px;\n\t\tmargin: 0 12px 0 0;\n\t\tfont-size: 12px;\n\t}\n\t.stepper-wrapper .ant-steps-item-container {\n\t\talign-items: start !important;\n\t}\n\t.stepper-wrapper .ant-steps-item.ant-steps-item-active .ant-steps-item-title,\n\t.stepper-wrapper .ant-steps-item .ant-steps-item-title{\n\t\tfont-size: 16px;\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
